import './operator.css';
import logo from '../../../assets/yantraimage.png';
import { FaRegClock, FaRegCalendarAlt, FaBell, FaSun, FaMoon, FaExternalLinkAlt } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import Swal from 'sweetalert2';
import { customerbaseddevices, customerbasedshift, Deviceattributeget, Downtimeadd1, getCustomerUsers, getFirstMachineActive, getMachineLock, operatorTelemetry, telemetrykeydata } from '../../Services/app/operatorservice';
import ReactDOMClient from 'react-dom/client';
import { keyframes } from "@mui/system";

import {
    FormControl,
    Select,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Autocomplete,
    TextField,
    InputLabel,
    Checkbox,
    ListItemText,
    IconButton,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { ROLE_OPERATOR } from '../../Shared/constants/role'
import { getOperatorDetails, Loginapi, startTokenAutoRefresh } from '../../Services/app/loginservice';
import { CustomDaySelect } from '../Inputfield/inputfield';
import CircularProgress from '../../Shared/Pages/circularprogress/circularprogress';
import ClockWidget from './ClockWidget';
import OperatorQueueButton from './OperatorQueueButton';
import VerticalProgress from '../../Shared/Pages/verticalprogress/verticalprogress';
import { useLocation } from 'react-router-dom';
import { cleanCustomerId, shiftadd } from '../../Services/app/masterservice';
import DynamicSlidingKeyboard from '../../Shared/Pages/dynamicSlidingKeyboard/dynamicSlidingKeyboard';
import { getReportGenerate1, getReportToken, getCurrentMachinePlan } from '../../Services/app/reportservice';

function Operator() {
    const [date, setDate] = useState(dayjs().format("DD-MM-YYYY"));
    const [time, setTime] = useState(dayjs().format("HH:mm:ss"));
    const [deviceThresholds, setDeviceThresholds] = useState({});
    const [currentShift, setCurrentShift] = useState(null)
    const [machines, setMachines] = useState([]);
    const [deviceNameIdJson, setDeviceNameIdJson] = useState({});
    const [selectedMachine, setSelectedMachine] = useState("");
    const [operators, setOperators] = useState([]);
    const [selectedOperator, setSelectedOperator] = useState("");
    const [operatorSearch, setOperatorSearch] = useState("");
    const [operatorMenuOpen, setOperatorMenuOpen] = useState(false);
    const [reasonslist, setreasonslist] = useState([]);
    const [reasons, setreasons] = useState([]);
    const [selectedDeviceId, setSelectedDeviceId] = useState(null);
    const [openDownTimeModal, setopenDownTimeModal] = useState(false);
    const [shifts, setShifts] = useState([]);
    const [shiftOptions, setShiftOptions] = useState([]);
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const [selectedShift, setSelectedShift] = useState(null);
    const [filteredResult, setfilteredResult] = useState([]);
    const [epochRange, setEpochRange] = useState({ from: null, to: null });
    const [loading, setLoading] = useState(false);
    const [isLocked, setIsLocked] = useState(false);
    const location = useLocation();
    const CustomerEmail = localStorage.getItem("email");
    const [telemetry, setTelemetry] = useState({
        machineStatus: "Unknown",
        targetParts: 0,
        totalShots: 0,
        goodParts: 0,
        scrap: 0,
        ncr: 0,
        jobName: "",
        jobCode: "",
    });
    const [currentOperator, setCurrentOperator] = useState(null);
    const [runningWO, setRunningWO] = useState(null); // Phase 13: live WO + route card on HMI
    const [pendingMachine, setPendingMachine] = useState("");
    const [pendingOperator, setPendingOperator] = useState("");
    const [activeView, setActiveView] = useState('efficiency'); // Smart Buddy views: efficiency | mes | report
    const [confirmType, setConfirmType] = useState(null);
    // ===== Operator assignment briefing state =====
    const [assignmentPlan, setAssignmentPlan] = useState({ groups: [] });
    const [identifiedOperator, setIdentifiedOperator] = useState(() => {
        try { return JSON.parse(localStorage.getItem('identified_operator') || 'null'); }
        catch { return null; }
    });
    const [identifyModalOpen, setIdentifyModalOpen] = useState(false);
    const [briefingOpen, setBriefingOpen] = useState(false);

    // ===== Pre-shift checklist state =====
    // Default items live in the component; can be overridden later via TB
    // attribute `operator_checklist_template`. Each item has a required flag —
    // the operator can't dismiss the modal until every required item is ticked.
    const DEFAULT_CHECKLIST = [
        { id: 'clean',    icon: '🧹', label: 'Machine cleaned',           sub: 'chips + coolant removed',      required: true },
        { id: 'coolant',  icon: '🛢️', label: 'Coolant level',              sub: 'checked + topped up',          required: true },
        { id: 'tools',    icon: '🔧', label: 'Tool offsets',               sub: 'verified',                     required: true },
        { id: 'drawing',  icon: '📋', label: 'Drawing revision',           sub: 'matches work order',           required: true },
        { id: 'guards',   icon: '🛡️', label: 'Safety guards',              sub: 'in place',                     required: true },
        { id: 'ppe',      icon: '🥽', label: 'PPE worn',                   sub: 'glasses · shoes · gloves',     required: true },
        { id: 'warmup',   icon: '🔥', label: 'Machine warmup',             sub: 'cycle complete',               required: false },
        { id: 'firstpc',  icon: '🔍', label: 'First-piece inspection',     sub: 'plan reviewed',                required: false },
    ];
    const [checklistOpen, setChecklistOpen] = useState(false);
    const [checklistDoneToday, setChecklistDoneToday] = useState(false);
    const [checklistItems, setChecklistItems] = useState(
        DEFAULT_CHECKLIST.reduce((acc, it) => ({ ...acc, [it.id]: false }), {})
    );
    const [checklistStep, setChecklistStep] = useState(0); // 0..N-1
    const [filterToMyMachines, setFilterToMyMachines] = useState(() =>
        localStorage.getItem('filter_to_my_machines') === '1'
    );
    const customerId1 = cleanCustomerId(localStorage.getItem('CustomerID'));
    const isSwalOpenRef = useRef(false);
    const [blueCardLogs, setBlueCardLogs] = useState([]);
    const [openBlueCardConfirm, setOpenBlueCardConfirm] = useState(false);
    const [requestPayload, setRequestPayload] = useState([]);
    const [isBlinking, setIsBlinking] = useState(false);
    const [blueCardText, setBlueCardText] = useState("Blue Card Push");
    const [openBlueCardSuccess, setOpenBlueCardSuccess] = useState(false);
    const [blueCardTimerStart, setBlueCardTimerStart] = useState(null);
    const [blueCardElapsed, setBlueCardElapsed] = useState(0);
    const blueCardTimerRef = useRef(null);
    const [routeCardNo, setRouteCardNo] = useState("");
    const [openReject, setOpenReject] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [existingCount, setExistingCount] = useState(0);
    const [rejectRows, setRejectRows] = useState([{ count: 0, reason: [], remark: "" }]);
    const [qualityReasonList, setQualityReasonList] = useState([]);
    const [isFetchingBluecard, setIsFetchingBluecard] = useState(false);
    const [prevOperatorData, setPrevOperatorData] = useState(null);
    const isValidRouteCard = /^[a-z0-9]+$/i.test(routeCardNo);
    const [openBlueCardResponse, setOpenBlueCardResponse] = useState(false);
    const [blueCardResponseData, setBlueCardResponseData] = useState(null);
    const prevRequestPayloadRef = useRef([]);
    const [isDark, setIsDark] = useState(() => localStorage.getItem('operatorTheme') === 'dark');


    useEffect(() => {
        document.body.setAttribute('data-theme', isDark ? 'dark' : 'light');
    }, [isDark]);

    // Load the saved operator_assignment_plan so we can match the identified
    // operator to their assigned machines (set by the supervisor in /operator-details).
    useEffect(() => {
        const cust = localStorage.getItem('CustomerID');
        if (!cust) return;
        customerbasedshift(cust, 'operator_assignment_plan')
            .then(r => {
                const plan = r?.[0]?.value;
                if (plan && typeof plan === 'object') setAssignmentPlan({ groups: plan.groups || [] });
            })
            .catch(() => { /* none */ });
    }, []);

    // Poll the assignment plan every 60s — when supervisor reassigns mid-shift,
    // operator's tablet picks it up and re-shows the brief automatically.
    useEffect(() => {
        const cust = localStorage.getItem('CustomerID');
        if (!cust || !identifiedOperator) return;
        const opId = String(identifiedOperator.operatorid || identifiedOperator.id || '');
        const refresh = async () => {
            try {
                const r = await customerbasedshift(cust, 'operator_assignment_plan');
                const plan = r?.[0]?.value;
                if (!plan || typeof plan !== 'object') return;
                const newGroups = plan.groups || [];
                const newMine = newGroups.find(g => String(g.operator_id) === opId);
                setAssignmentPlan(prev => {
                    const prevMine = (prev?.groups || []).find(g => String(g.operator_id) === opId);
                    const prevFp = prevMine?.fingerprint || '';
                    const newFp = newMine?.fingerprint || '';
                    // My machine set CHANGED — invalidate the day's ack so brief re-shows
                    if (newFp && prevFp && prevFp !== newFp) {
                        const today = new Date().toISOString().slice(0, 10);
                        localStorage.removeItem(`brief_ack_${opId}_${today}`);
                        setBriefingOpen(true);
                    }
                    return { groups: newGroups, updated_at: plan.updated_at };
                });
            } catch { /* non-fatal */ }
        };
        const id = setInterval(refresh, 60000);
        return () => clearInterval(id);
    }, [identifiedOperator]);

    // Auto-link the EXISTING selectedOperator (set via the operator dropdown at
    // the bottom of the screen, e.g. "009 - suresh") to identifiedOperator so
    // the visual brief auto-triggers without needing a separate identify modal.
    useEffect(() => {
        if (!selectedOperator || !operators || operators.length === 0) return;
        const matched = operators.find(op => String(op.id) === String(selectedOperator)
            || String(op.operatorid) === String(selectedOperator));
        if (matched && (!identifiedOperator ||
            String(identifiedOperator.id) !== String(matched.id))) {
            setIdentifiedOperator(matched);
            localStorage.setItem('identified_operator', JSON.stringify(matched));
        }
    }, [selectedOperator, operators]);

    // Derive the identified operator's assigned group from the plan
    const myAssignedGroup = (() => {
        if (!identifiedOperator) return null;
        const opId = String(identifiedOperator.operatorid || identifiedOperator.id || '');
        return (assignmentPlan?.groups || []).find(g =>
            String(g.operator_id) === opId
        );
    })();

    const myAssignedMachineNames = (myAssignedGroup?.machines || []).map(m => m.name);

    // First time we identify an operator (or first time today), pop up the pre-shift checklist
    useEffect(() => {
        if (!identifiedOperator) return;
        const today = new Date().toISOString().slice(0, 10);
        const opId = identifiedOperator.operatorid || identifiedOperator.id || '';
        const ackKey = `checklist_done_${opId}_${today}`;
        if (localStorage.getItem(ackKey) === '1') {
            setChecklistDoneToday(true);
        } else {
            setChecklistDoneToday(false);
            setChecklistOpen(true);
            setChecklistStep(0);
        }
    }, [identifiedOperator]);

    const submitChecklist = async () => {
        const today = new Date().toISOString().slice(0, 10);
        const opId = identifiedOperator?.operatorid || identifiedOperator?.id || '';
        const ackKey = `checklist_done_${opId}_${today}`;
        const cust = getCustomerId();
        const logEntry = {
            operator_id: opId,
            operator_name: identifiedOperator?.operatorname || identifiedOperator?.name || '',
            date: today,
            completed_at: new Date().toISOString(),
            items: checklistItems,
        };
        try {
            // Append to customer-level log (read existing, push, write back)
            const existing = await customerbasedshift(cust, 'operator_checklist_log');
            const arr = existing?.[0]?.value;
            const log = Array.isArray(arr) ? arr : [];
            log.unshift(logEntry); // newest first
            if (log.length > 500) log.length = 500; // cap
            await shiftadd({ operator_checklist_log: log }, cust, 'SERVER_SCOPE');
        } catch (e) {
            console.error('[checklist] log write failed:', e);
        }
        localStorage.setItem(ackKey, '1');
        setChecklistDoneToday(true);
        setChecklistOpen(false);
    };

    // First time we identify an operator (or first time today), pop up the visual brief
    useEffect(() => {
        if (!identifiedOperator || !myAssignedGroup) return;
        const today = new Date().toISOString().slice(0, 10);
        const ackKey = `brief_ack_${identifiedOperator.operatorid || identifiedOperator.id}_${today}`;
        if (localStorage.getItem(ackKey) !== '1') {
            setBriefingOpen(true);
        }
    }, [identifiedOperator, myAssignedGroup]);

    const acknowledgeBrief = async () => {
        const today = new Date().toISOString().slice(0, 10);
        const opIdLocal = identifiedOperator.operatorid || identifiedOperator.id;
        const ackKey = `brief_ack_${opIdLocal}_${today}`;
        localStorage.setItem(ackKey, '1');
        setBriefingOpen(false);
        // Default to filtered view after acknowledging the brief
        setFilterToMyMachines(true);
        localStorage.setItem('filter_to_my_machines', '1');
        // Write ack back to the plan so supervisor sees who's clocked in/read brief
        if (myAssignedGroup && assignmentPlan?.groups?.length) {
            try {
                const updatedGroups = assignmentPlan.groups.map(g =>
                    g.fingerprint === myAssignedGroup.fingerprint
                        ? { ...g, acknowledged_at: Date.now(),
                            acknowledged_by: identifiedOperator.operatorname || identifiedOperator.name }
                        : g
                );
                const updatedPlan = { ...assignmentPlan, groups: updatedGroups, updated_at: Date.now() };
                const cust = localStorage.getItem('CustomerID');
                if (cust) await shiftadd({ operator_assignment_plan: updatedPlan }, cust, 'SERVER_SCOPE');
                setAssignmentPlan(updatedPlan);
            } catch (e) {
                console.error('[brief] ack write failed:', e);
            }
        }
    };

    const switchOperator = () => {
        localStorage.removeItem('identified_operator');
        setIdentifiedOperator(null);
        setFilterToMyMachines(false);
        localStorage.removeItem('filter_to_my_machines');
        setIdentifyModalOpen(true);
    };

    const toggleTheme = () => {
        setIsDark(prev => {
            const next = !prev;
            localStorage.setItem('operatorTheme', next ? 'dark' : 'light');
            return next;
        });
    };

    const t = {
        bg: isDark ? '#22262e' : '#ffffff',
        bgCard: isDark ? '#2a2f3a' : '#f5f6fa',
        bgRow: isDark ? '#2a2f3a' : '#fafafa',
        text: isDark ? '#f1f5f9' : '#111827',
        textSub: isDark ? '#94a3b8' : '#6b7280',
        border: isDark ? '#334155' : '#e5e7eb',
        borderTable: isDark ? '#334155' : '#ccc',
        borderLight: isDark ? '#334155' : '#e0e0e0',
        borderRow: isDark ? '#334155' : '#f0f0f0',
        tableHeader: isDark ? '#2a2f3a' : '#f2f2f2',
        dialogContent: isDark ? '#22262e' : '#fff',
        headerBorder: isDark ? '#334155' : '#e8eaf0',
    };
    const [blueCardNotifications, setBlueCardNotifications] = useState([]);
    const [showBlueCardNotif, setShowBlueCardNotif] = useState(false);
    const prevComponentCodeRef = useRef(null);
    const notifBellRef = useRef(null);
    const [liveCompSelected, setLiveCompSelected] = useState('');
    const [prevLiveComp, setPrevLiveComp] = useState(null);
    const prevShiftRef = useRef(null);
    const [currentMachinePlan, setCurrentMachinePlan] = useState(null);
    const getCustomerId = () => {
        const params = new URLSearchParams(location.search);
        const queryCustomerId = params.get('customer_id') || params.get('customer');
        if (queryCustomerId) {
            return queryCustomerId;
        } else if (location.pathname === "/wP7n_AqZ9-rtY4X8jvS2T6eK0uL3MhQxGdN5oRc~1fHbJiV") {
            return window._env_.CUSTOMER_ID;
        } else if (location.pathname === "/smc_operator_bf9tz") {
            return window._env_.SMC_CUSTOMER_ID;
        } else if (location.pathname === "/atech_operator_atc67") {
            return window._env_.ATECH_CUSTOMER_ID;
        } else if (location.pathname === "/marks_operator_ch8st") {
            return window._env_.MARKS_CUSTOMER_ID;
        } else if (location.pathname === "/makino_operator_av5tc") {
            return window._env_.MAKINO_CUSTOMER_ID;
        } else if (location.pathname === "/demo_operator_av3tc") {
            return window._env_.DEMO_CUSTOMER_ID;
        } else if (location.pathname === "/gplast_operator_awe6tc") {
            return window._env_.GPLAST_CUSTOMER_ID;
        } else if (location.pathname === "/operator_screen_biotek") {
            return window._env_.BIOTEK_CUSTOMER_ID;
        } else {
            const customerIdStr = localStorage.getItem('CustomerID');
            try {
                return JSON.parse(customerIdStr);
            } catch (error) {
                console.error('Error parsing CustomerID from localStorage:', error);
                return customerIdStr;
            }
        }
    };
    const isPMIBlueCardPage =
        location.pathname === "/wP7n_AqZ9-rtY4X8jvS2T6eK0uL3MhQxGdN5oRc~1fHbJiV" ||
        cleanCustomerId(getCustomerId()) === window._env_.CUSTOMER_ID;

    const isGplastCondition =
        location.pathname === "/gplast_operator_awe6tc" ||
        cleanCustomerId(getCustomerId()) === window._env_.GPLAST_CUSTOMER_ID;

    const isAtechCondition =
        location.pathname === "/atech_operator_atc67" ||
        cleanCustomerId(getCustomerId()) === window._env_.ATECH_CUSTOMER_ID ||
        cleanCustomerId(getCustomerId()) === window._env_.UNIJET_CUSTOMER_ID;

        const fetchDevices = async () => {
        try {
            const customerId = getCustomerId();
            const result = await customerbaseddevices(customerId, 1000, 0);
            const devicesList = result.data || [];
            setMachines(devicesList.map((d) => d.name).sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })));
            const nameIdMap = devicesList.reduce((acc, device) => {
                acc[device.name] = device.id.id;
                return acc;
            }, {});
            setDeviceNameIdJson(nameIdMap);
            const machineInfo = JSON.parse(localStorage.getItem("machineInfo"));
            if (machineInfo?.machine_name && machineInfo?.machine_id) {
                setSelectedMachine(machineInfo.machine_name);
            } else if (devicesList.length > 0) {
                const savedMachine = localStorage.getItem("selectedMachine");
                if (savedMachine && devicesList.some((d) => d.name === savedMachine)) {
                    setSelectedMachine(savedMachine);
                } else {
                    const defaultMachine = devicesList[0].name;
                    setSelectedMachine(defaultMachine);
                    localStorage.setItem("selectedMachine", defaultMachine);
                }
            }
            const qualityResult = await customerbasedshift(customerId, "qualityreason");
            setQualityReasonList(qualityResult?.[0]?.value || []);
        } catch (err) {
            console.error("Failed to fetch devices", err);
        }
    };

    const formatDuration = (durationInSeconds) => {
        const hours = Math.floor(durationInSeconds / 3600);
        const minutes = Math.floor((durationInSeconds % 3600) / 60);
        const seconds = durationInSeconds % 60;
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    const formatEpochToIST = (epoch) => {
        const options = { timeZone: 'Asia/Kolkata' };
        const date = new Date(epoch).toLocaleString('en-US', options);
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        const seconds = String(d.getSeconds()).padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    function getShiftEpoch(startTime = "06:00", endTime = "14:00") {
        const now = dayjs();
        const [startH, startM] = startTime.split(":").map(Number);
        const [endH, endM] = endTime.split(":").map(Number);
        let shiftStart = dayjs().hour(startH).minute(startM).second(0).millisecond(0);
        let shiftEnd = dayjs().hour(endH).minute(endM).second(0).millisecond(0);
        if (shiftEnd.isBefore(shiftStart)) {
            if (now.isBefore(shiftEnd)) {
                shiftStart = shiftStart.subtract(1, "day");
            } else {
                shiftEnd = shiftEnd.add(1, "day");
            }
        }
        const shiftStartEpoch = shiftStart.valueOf();
        const shiftEndEpoch = shiftEnd.valueOf();
        const nowEpoch = now.valueOf();
        const progress = Math.min(Math.max(((nowEpoch - shiftStartEpoch) / (shiftEndEpoch - shiftStartEpoch)) * 100, 0), 100);
        return { shiftStart: shiftStartEpoch, shiftEnd: shiftEndEpoch, now: nowEpoch, progress };
    }

    const statusText = (code) => {
        switch (code) {
            case 0:
            case 1:
            case 2:
                return "idle";
            case 3:
                return "running";
            case 5:
                return "alarm";
            case 100:
                return "disconnect";
            default:
                return "unknown";
        }
    };


    // const fetchOperators = async () => {
    //   try {
    //     let operatorList = [];

    //     if (location.pathname === "/wP7n_AqZ9-rtY4X8jvS2T6eK0uL3MhQxGdN5oRc~1fHbJiV") {
    //       const res = await customerbasedshift(getCustomerId(), "alloperator");
    //       const allData = res?.[0]?.value || [];
    //       operatorList = allData
    //         .filter(o => o?.mode?.toLowerCase() === 'operator')
    //         .map(op => ({ id: op.operatorid, name: op.operatorname }));
    //     } else {
    //       // 👤 From user list API
    //       const res = await getCustomerUsers(customerId1);
    //       const users = res.data || [];
    //       const parsedUsers = users.map(u => {
    //         let desc = "";
    //         try {
    //           desc = u.additionalInfo?.description
    //             ? JSON.parse(u.additionalInfo.description)
    //             : "";
    //         } catch {
    //           desc = u.additionalInfo?.description || "";
    //         }
    //         return { ...u, userDetails: desc };
    //       });

    //       operatorList = parsedUsers
    //         .filter(u => u.userDetails?.mode?.toLowerCase() === 'operator')
    //         .map(u => ({ id: u.userDetails?.userId, name: u.firstName }));
    //     }
    //     setOperators(operatorList);
    //   } catch (error) {
    //     console.error("Error fetching operators:", error);
    //     setOperators([]);
    //   }
    // };

    const fetchOperators = async () => {
        try {
            let operatorList = [];
            const res = await customerbasedshift(getCustomerId(), "alloperator");
            const allData = res?.[0]?.value || [];
            const seen = new Set();
            operatorList = allData
                .filter(o => o?.mode?.toLowerCase() === 'operator')
                .map(op => ({ id: op.operatorid, name: op.operatorname }))
                .filter(op => {
                    const key = String(op.id);
                    if (seen.has(key)) return false;
                    seen.add(key);
                    return true;
                })
                .sort((a, b) => {
                    const numA = parseInt(a.id, 10);
                    const numB = parseInt(b.id, 10);
                    if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
                    return String(a.id).localeCompare(String(b.id));
                });
            setOperators(operatorList);
        } catch (error) {
            console.error("Error fetching operators:", error);
            setOperators([]);
        }
    };



    const fetchTelemetry = async (deviceId) => {
        try {
            const response = await customerbasedshift(
                getCustomerId(),
                "allShift"
            );
            const shifts = response[0]?.value || [];
            setShifts(shifts);
            const currentActiveShift = await getCurrentShift(shifts, dayjs());
            const { shiftStart, now, shiftEnd } = getShiftEpoch(currentActiveShift?.start_time, currentActiveShift?.end_time);
            await fetchOperators();
            const keysConfig = [
                { key: "machine_status", isJson: false },
                { key: "targetparts", isJson: false },
                { key: "totalparts", isJson: true },
                { key: "live_operator", isJson: true },
                { key: "live_component", isJson: true },
                { key: "operations", isJson: true },
                { key: "live_plan", isJson: true },
            ];
            const data = await getFirstMachineActive("DEVICE", deviceId, {
                keys: keysConfig.map(k => k.key).join(","),
                startTs: shiftStart || Date.now() - 3600000,
                endTs: shiftEnd || Date.now(),
            });
            const filteredData = {
                ...data,
                live_operator: (data.live_operator || []).filter(item => item.ts <= now),
                live_plan: (data.live_plan || []).filter(item => item.ts <= now),
            };
            const getLatest = (key, isJson = false) => {
                const arr = filteredData[key];
                if (!arr || arr.length === 0) return isJson ? {} : null;
                const value = arr[0].value;
                if (!isJson) return value;
                try {
                    return JSON.parse(value);
                } catch (err) {
                    console.error(`Error parsing JSON for key: ${key}`, err);
                    return {};
                }
            };
            const getLatestWithTs = (key, isJson = false) => {
                const arr = filteredData[key];
                if (!Array.isArray(arr) || arr.length === 0) return isJson ? {} : null;
                const value = arr[0];
                if (!isJson) return value;
                try {
                    return {
                        ts: value.ts,
                        value: JSON.parse(value.value)
                    };
                } catch (err) {
                    console.error(`Error parsing JSON for key: ${key}`, err);
                    return { ts: value.ts, value: null };
                }
            };
            const machineStatusArray = filteredData.machine_status || [];
            const latestStatusCode = parseInt(machineStatusArray[0]?.value || 0, 10);
            const machineStatus = statusText(latestStatusCode);
            const firstActive = machineStatusArray
                .slice()
                .reverse()
                .find(item => item.value === "3")?.ts || null;
            const statusColor =
                machineStatus.toLowerCase() === "running"
                    ? "#3DA06A"
                    : machineStatus.toLowerCase() === "idle"
                        ? "#DD6B20"
                        : machineStatus.toLowerCase() === "alarm"
                            ? "#E53E3E"
                            : machineStatus.toLowerCase() === "disconnect"
                                ? "#808080"
                                : "#ccc";
            const targetParts = parseInt(getLatest("targetparts") || 0, 10);
            const totalParts = getLatest("totalparts", true);
            const { totalshots = 0, goodparts = 0, scrap = 0, ncr = 0 } = totalParts;
            const livePlan = getLatest("live_plan", true);
            const liveComponent = getLatest("live_component", true);
            const operations = getLatest("operations", true);
            const livePlanTs = filteredData.live_plan?.[0]?.ts || null;
            const liveComponentTs = filteredData.live_component?.[0]?.ts || null;
            const operationsTs = filteredData.operations?.[0]?.ts || null;
            const shouldUseGplastPlan = isGplastCondition && window._env_.GPLAST_DEVICE_IDS?.includes(deviceId);
            const jobName = (shouldUseGplastPlan ? livePlan.name : liveComponent.name) || "Route card not assigned";
            const jobCode = (shouldUseGplastPlan ? livePlan.code : liveComponent.code) || "";
            const liveOperator = getLatestWithTs("live_operator", true);
            const liveOperatorCode = liveOperator?.value?.code || null;
            setTelemetry({
                machineStatus,
                machineColor: statusColor,
                firstActive,
                targetParts,
                totalShots: totalshots,
                goodParts: goodparts,
                scrap,
                ncr,
                jobName,
                jobCode,
                livePlan,
                livePlanTs,
                liveComponent,
                liveComponentTs,
                operations,
                operationsTs,
                liveOperatorCode,
                liveOperator
            });
            if (liveOperator?.value) {
                setCurrentOperator({ ...liveOperator.value, ts: liveOperator.ts });
            }
            return filteredData;
        } catch (err) {
            console.error("Telemetry fetch failed", err);
        }
    };

    const getCurrentShift = (allShifts, selectedDate = dayjs()) => {
        const now = dayjs(selectedDate);
        for (let shift of allShifts) {
            const [startH, startM, startS = 0] = shift.start_time.split(":").map(Number);
            const [endH, endM, endS = 0] = shift.end_time.split(":").map(Number);
            let start = dayjs(now).hour(startH).minute(startM).second(startS).millisecond(0);
            let end = dayjs(now).hour(endH).minute(endM).second(endS).millisecond(0);
            if (end.isBefore(start)) {
                if (now.isBefore(end)) {
                    start = start.subtract(1, "day");
                } else {
                    end = end.add(1, "day");
                }
            }
            if (now.isAfter(start) && now.isBefore(end)) {
                return shift;
            }
        }
        return null;
    };

    const fetchReasonGroups = async () => {
        const key = "reasongroups";
        try {
            const customerId = getCustomerId();
            const data = await customerbasedshift(customerId, key);
            const allReasonGroups = Array.isArray(data?.[0]?.value)
                ? data[0].value
                : [];
            const mappedGroups = [
                { value: "all", label: "All Groups" },
                ...allReasonGroups.map(item => ({
                    value: item.groupName || item.name || "",
                    label: item.groupName || item.name || "",
                })),
            ];
            setReasonGroupOptions(mappedGroups);
            return mappedGroups;
        } catch (error) {
            console.error("❌ Error fetching reason groups:", error);
            setReasonGroupOptions([{ value: "", label: "All Groups" }]);
            return [{ value: "", label: "All Groups" }];
        }
    };

    const downtimereason = async ({ shiftNo, selectedDate, fromEpoch, toEpoch, deviceId }) => {
        if (!deviceId || !shiftNo || !selectedDate || !fromEpoch || !toEpoch) return [];
        await fetchReasonGroups()
        const fromTime = fromEpoch;
        const toTime = toEpoch;

        try {
            const machineStatusResponse = await telemetrykeydata(deviceId, "DEVICE", "machine_status", fromTime, toTime);
            const machineData = machineStatusResponse?.machine_status || [];

            const sortedData = [...machineData].sort((a, b) => Number(a.ts) - Number(b.ts));
            const transformedData = sortedData
                .filter(item => item.ts && item.value !== undefined)
                .map(item => ({ ts: item.ts, value: Number(item.value) }));
            const IDLE_START_CODES = [0, 1, 2];
            const IDLE_END_CODES = [3, 4, 5, 100];

            const extractIdleSegments = (data) => {
                const result = [];
                let recording = false;
                let segment = { start: null, value: null };

                for (let i = 0; i < data.length; i++) {
                    const current = data[i];
                    const val = current.value;

                    if (!recording && IDLE_START_CODES.includes(val)) {
                        segment.start = current.ts;
                        segment.value = val;
                        recording = true;
                    }

                    if (recording && IDLE_END_CODES.includes(val)) {
                        segment.end = current.ts;
                        const duration = Math.floor((segment.end - segment.start) / 1000);
                        result.push({
                            start: segment.start,
                            end: segment.end,
                            duration,
                            value: segment.value,
                            status: "IDLE",
                        });
                        recording = false;
                        segment = { start: null, value: null };
                    }

                    if (recording && IDLE_START_CODES.includes(val)) {
                        segment.value = val;
                    }
                }

                if (recording) {
                    const lastKnownTs = data.length > 0 ? data[data.length - 1].ts : fromTime;
                    const now = Date.now();
                    const safeEnd = Math.min(toTime, now, lastKnownTs);
                    segment.end = safeEnd;
                    const duration = Math.floor((segment.end - segment.start) / 1000);
                    result.push({
                        start: segment.start,
                        end: segment.end,
                        duration,
                        value: segment.value,
                        status: "IDLE",
                    });
                }

                return result.length > 0
                    ? result
                    : [{ start: fromTime, end: toTime, duration: 0, value: 0, status: "NO_DATA" }];
            };

            const key = "downtime_threasold";
            const results = await Deviceattributeget(deviceId, key);
            let filteredResult = [];
            if (results && results.length > 0) {
                const downtime = results[0].value;
                const extracted = extractIdleSegments(transformedData);
                filteredResult = extracted.filter(entry => entry.duration > downtime);
            }

            const response = await telemetrykeydata(deviceId, "DEVICE", "live_reason", fromEpoch, toEpoch);
            if (response?.live_reason?.length > 0) {
                const parsedLiveReasons = response.live_reason
                    .map(entry => {
                        try { return { ts: entry.ts, ...JSON.parse(entry.value) }; }
                        catch { return null; }
                    })
                    .filter(Boolean);

                const unusedLiveReasons = [...parsedLiveReasons];

                filteredResult = filteredResult.map(item => {
                    const index = unusedLiveReasons.findIndex(reason => {
                        const reasonStart = Number(reason.idle_start);
                        const reasonEnd = reason.idle_end && reason.idle_end !== 0 ? Number(reason.idle_end) : reasonStart;
                        return reasonStart <= item.end && reasonEnd >= item.start;
                    });
                    let reasonName = "";
                    let reasonGroup = "";
                    if (index !== -1) {
                        reasonName = unusedLiveReasons[index].name;
                        const matchedReason = reasonsList2.find(
                            r =>
                                r.reason?.toLowerCase() === reasonName?.toLowerCase() ||
                                r.code?.toString() === unusedLiveReasons[index].code?.toString()
                        );
                        reasonGroup = matchedReason?.group || "all";
                        unusedLiveReasons.splice(index, 1);
                    }

                    return {
                        ...item,
                        groupselected: reasonGroup,
                        reasonselected: reasonName || item.reasonselected || ""
                    };
                });

            }
            return filteredResult;
        } catch (error) {
            console.error("Error fetching downtime data:", error);
            return [];
        }
    };

    const handleGroupChange = (index, selectedGroup) => {
        setfilteredResult(prev => {
            const updated = [...prev];
            updated[index].groupselected = selectedGroup;
            updated[index].reasonselected = "";
            return updated;
        });
    };
    const [firstMachineActive, setFirstMachineActive] = useState(null);

    useEffect(() => {
        let timer;
        let interval;

        const getAllShifts = async () => {
            try {
                if (!Object.keys(deviceNameIdJson).length) {
                    await fetchDevices();
                }

                const response = await customerbasedshift(
                    getCustomerId(),
                    "allShift"
                );
                const shifts = response[0]?.value || [];
                setShifts(shifts);
                const currentActiveShift = await getCurrentShift(shifts, dayjs());
                if (!currentActiveShift) return;

                const formattedShift = {
                    ...currentActiveShift,
                    start_time: currentActiveShift.start_time.slice(0, 5),
                    end_time: currentActiveShift.end_time.slice(0, 5),
                };
                setCurrentShift(formattedShift);
                setSelectedShift(currentActiveShift.shift_no);
                const startTime = dayjs(`${dayjs().format("YYYY-MM-DD")} ${formattedShift.start_time}`, "YYYY-MM-DD HH:mm");
                let endTime = dayjs(`${dayjs().format("YYYY-MM-DD")} ${formattedShift.end_time}`, "YYYY-MM-DD HH:mm");
                if (currentActiveShift.start_day !== currentActiveShift.end_day) {
                    endTime = endTime.add(1, "day");
                }

                const now = dayjs();
                const delay = endTime.diff(now);

                if (delay > 0) {
                    timer = setTimeout(() => {
                        getAllShifts();
                    }, delay);
                }
            } catch (err) {
                console.error("Error in getAllShifts:", err);
            }
        };

        getAllShifts();

        interval = setInterval(() => {
            getAllShifts();
        }, 60 * 1000);

        return () => {
            clearTimeout(timer);
            clearInterval(interval);
        };
    }, [selectedMachine]);

    const getShiftDate = (shift) => {
        const now = new Date();
        const [startH, startM] = shift.start_time.split(':').map(Number);
        const [endH, endM] = shift.end_time.split(':').map(Number);
        const nowMins = now.getHours() * 60 + now.getMinutes();
        const startMins = startH * 60 + startM;
        const endMins = endH * 60 + endM;
        // Midnight-crossing shift: end time is earlier than start time (e.g. 22:00 → 06:00)
        const isMidnightShift = endMins <= startMins;
        const shiftDate = new Date(now);
        if (isMidnightShift && nowMins < endMins) {
            // We're in the early-morning portion — shift started yesterday
            shiftDate.setDate(shiftDate.getDate() - 1);
        }
        const yyyy = shiftDate.getFullYear();
        const mm = String(shiftDate.getMonth() + 1).padStart(2, '0');
        const dd = String(shiftDate.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    const planDate = currentShift ? getShiftDate(currentShift) : null;

    useEffect(() => {
        if (!selectedMachine || !currentShift?.shift_no || !planDate) return;
        const deviceId = deviceNameIdJson[selectedMachine];
        const shouldUseGplastPlan = isGplastCondition && window._env_.GPLAST_DEVICE_IDS?.includes(deviceId);
        if (!shouldUseGplastPlan) return;
        const fetchCurrentMachinePlan = async () => {
            try {
                const credential = isGplastCondition ? "gd" : "gd";
                await getReportToken(credential, credential);
                const data = await getCurrentMachinePlan(selectedMachine, currentShift.shift_no, planDate);
                const planList = Array.isArray(data) ? data : (data?.plans || []);
                setCurrentMachinePlan(planList);
                console.log('Current machine plan:', planList);
            } catch (err) {
                console.error('Error fetching current machine plan:', err);
            }
        };
        fetchCurrentMachinePlan();
    }, [selectedMachine, currentShift?.shift_no, planDate]);

    const openDownTime = async (devicename, deviceid) => {
        const customerId = getCustomerId();
        setLoading(true);
        try {
            const [reasonsData, shiftsData] = await Promise.all([
                customerbasedshift(customerId, "reason"),
                customerbasedshift(customerId, "allShift"),
            ]);
            const allReasons = reasonsData[0]?.value || [];
            setreasonslist(allReasons);
            setreasons(allReasons.map(r => ({ value: r.reason, label: r.reason, group: r.group || "" })));
            const allShifts = shiftsData[0]?.value || [];
            setShifts(allShifts);
            const options = allShifts.map(shift => ({
                value: shift.shift_no,
                label: `Shift${shift.shift_no}`,
            }));
            setShiftOptions(options);
            setSelectedDeviceId(deviceid);
            setSelectedDate(dayjs());
            setfilteredResult([]);
            const currentShift = getCurrentShift(allShifts);
            let chosenShiftNo = currentShift?.shift_no || (options.length > 0 ? options[0].value : null);
            if (chosenShiftNo) {
                setSelectedShift(chosenShiftNo);
                const { shiftStart: fromEpoch, now: toEpoch } = getShiftEpoch(currentShift?.start_time);
                setEpochRange({ from: fromEpoch, to: toEpoch });
                const data = await downtimereason({
                    shiftNo: chosenShiftNo,
                    selectedDate: dayjs(),
                    fromEpoch,
                    toEpoch,
                    deviceId: deviceid,
                });
                console.log([...data].reverse(), 'data table')
                setfilteredResult([...data].reverse());
                setopenDownTimeModal(true);
            } else {
                console.warn("⚠️ No active shift found right now");
            }
        } catch (err) {
            console.error("Error in openDownTime:", err);
        } finally {
            setLoading(false);
        }
    };


    const [reasonsList2, setReasonsList2] = useState([])

    useEffect(() => {
        const getReasons = async () => {
            try {
                const response = await customerbasedshift(getCustomerId(), "reason");
                const reasons = response?.[0]?.value || [];
                setReasonsList2(reasons);
            } catch (err) {
                console.error("Error fetching reasons:", err);
            }
        };
        getReasons();
        const interval = setInterval(getReasons, 5000);
        return () => clearInterval(interval);
    }, []);

    const [idleStartTime, setIdleStartTime] = useState(null);

    // near top of component

    // near top of component
    // --- refs only ---
    const prevStatusRef = useRef(null);
    const lockedIdleStartRef = useRef(null);
    const activeReasonRef = useRef(null);
    const isLockedRef = useRef(false);

    // On mount, restore any locked idle info from localStorage
    useEffect(() => {
        const savedLockedIdleStart = localStorage.getItem("lockedIdleStartTime");
        const savedActiveReason = localStorage.getItem("activeReason");

        if (savedLockedIdleStart && savedActiveReason) {
            lockedIdleStartRef.current = Number(savedLockedIdleStart);
            activeReasonRef.current = JSON.parse(savedActiveReason);
            isLockedRef.current = true;
            console.log("[INIT] restored locked idle from storage", savedLockedIdleStart, savedActiveReason);
        }
    }, []);


    function parseShifts(allShifts) {
        return allShifts.map(shift => {
            const today = dayjs();
            const startDayOffset = shift.start_day - 1;
            const endDayOffset = shift.end_day - 1;
            let startTs = dayjs(today)
                .startOf("day")
                .add(startDayOffset, "day")
                .hour(Number(shift.start_time.split(":")[0]))
                .minute(Number(shift.start_time.split(":")[1]))
                .second(Number(shift.start_time.split(":")[2]));
            let endTs = dayjs(today)
                .startOf("day")
                .add(endDayOffset, "day")
                .hour(Number(shift.end_time.split(":")[0]))
                .minute(Number(shift.end_time.split(":")[1]))
                .second(Number(shift.end_time.split(":")[2]));
            if (endTs.isBefore(startTs)) {
                endTs = endTs.add(1, "day");
            }
            return {
                shift_no: shift.shift_no,
                startTs: startTs.valueOf(),
                endTs: endTs.valueOf(),
            };
        });
    }

    function splitIdleByShifts(idleStart, idleEnd, shifts) {
        const segments = [];
        shifts.forEach((shift) => {
            const overlapStart = Math.max(idleStart, shift.startTs);
            const overlapEnd = Math.min(idleEnd, shift.endTs);
            if (overlapStart < overlapEnd) {
                segments.push({
                    shift_no: shift.shift_no,
                    start: overlapStart,
                    end: overlapEnd
                });
            }
        });

        return segments;
    }

    useEffect(() => {
        const customerId = getCustomerId();
        if (cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID) return;
        if (!selectedMachine || !deviceNameIdJson[selectedMachine]) return;
        const deviceId = deviceNameIdJson[selectedMachine];
        const openReasonSwal = (idleStart, reasonsList2, previousReason = null) => {
            const reasonOptions = reasonsList2
                .map(
                    r =>
                        `<option value="${r.id}" ${previousReason?.id === r.id ? "selected" : ""
                        }>${r.reason}</option>`
                )
                .join("");

            Swal.fire({
                icon: "info",
                title: "Machine Locked",
                html: `<p>Machine has been locked due to downhold threshold reached.</p>
             <label for="reason">Select Reason:</label>
             <select id="reason" class="swal2-select">
               <option value="">-- Select --</option>
               ${reasonOptions}
             </select>`,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCancelButton: false,
                confirmButtonText: "Submit",
                preConfirm: () => {
                    const reasonId = document.getElementById("reason").value;
                    if (!reasonId) {
                        Swal.showValidationMessage("Please select a reason");
                        return false;
                    }
                    return reasonsList2.find(r => r.id === reasonId);
                },
            }).then(result => {
                if (result.isConfirmed) {
                    const selectedReason = result.value;
                    activeReasonRef.current = selectedReason;
                    localStorage.setItem("lockedIdleStartTime", idleStart);
                    localStorage.setItem("activeReason", JSON.stringify(selectedReason));

                    Swal.fire({
                        icon: "question",
                        title: "Confirm Submission",
                        text: `You selected: ${selectedReason.reason}. Do you want to confirm?`,
                        showCancelButton: true,
                        confirmButtonText: "Yes, Submit",
                        cancelButtonText: "No, Go Back",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(async confirmResult => {
                        if (confirmResult.isConfirmed) {
                            const payload = {
                                ts: idleStart,
                                values: {
                                    live_reason: {
                                        name: selectedReason.reason,
                                        code: selectedReason.code || "",
                                        mode: selectedReason.mode || "",
                                        category: selectedReason.category || "",
                                        idle_start: idleStart,
                                        idle_end: 0,
                                        idle_duration: 0,
                                    },
                                },
                            };
                            try {
                                await operatorTelemetry("DEVICE", deviceId, payload);
                                await operatorTelemetry("DEVICE", deviceId, {
                                    lock_status: "unlocked",
                                });
                                console.log(
                                    "[LOCKED_IDLE] reason submitted, machine unlocked, waiting for running to close idle"
                                );
                                Swal.fire({
                                    icon: "success",
                                    title: "Submitted!",
                                    text: "Reason submitted successfully.",
                                    timer: 1500,
                                    showConfirmButton: false,
                                });
                            } catch (err) {
                                console.error("Error submitting reason:", err);
                                Swal.fire({
                                    icon: "error",
                                    title: "Error",
                                    text: "Failed to submit reason. Please try again.",
                                });
                            }
                        } else {
                            openReasonSwal(idleStart, reasonsList2, selectedReason);
                        }
                    });
                }
            });
        };

        const refreshData = async (checkRestore = false) => {
            try {
                const data = await fetchTelemetry(deviceId);
                let machineStatusArray = data?.machine_status || [];
                if (!machineStatusArray.length) return;
                machineStatusArray = machineStatusArray.slice().sort((a, b) => b.ts - a.ts);
                const latestSample = machineStatusArray[0];
                const latestValue = String(latestSample?.value ?? "").trim();
                const latestStatus = parseInt(latestValue || "0", 10);
                const IDLE_START_CODES = ["0", "1", "2"];
                const IDLE_END_CODES = ["3", "4", "5", "100"];
                const latestStatusText = statusText(latestStatus).toLowerCase();
                console.log("[refreshData] latestValue:", latestValue, "latestStatus:", latestStatusText);
                const response = await getMachineLock("DEVICE", deviceId, { keys: "lock_status" });
                const lockValue = response?.lock_status?.[0]?.value || "";
                const locked = String(lockValue).toLowerCase() === "locked";
                if (!locked && isLockedRef.current) {
                    console.log("[refreshData] unlocking via lock API");
                    isLockedRef.current = false;
                    Swal.close();
                }
                if (locked && !isLockedRef.current) {
                    console.log("[refreshData] detected lock -> opening Swal");
                    isLockedRef.current = true;
                    let lastIdleOrAlarm = null;
                    for (let i = 0; i < machineStatusArray.length - 1; i++) {
                        const current = machineStatusArray[i];
                        const next = machineStatusArray[i + 1];
                        if (IDLE_END_CODES.includes(String(next.value)) && IDLE_START_CODES.includes(String(current.value))) {
                            lastIdleOrAlarm = current;
                            break;
                        }
                    }
                    if (!lastIdleOrAlarm) {
                        lastIdleOrAlarm = machineStatusArray.find(item => IDLE_START_CODES.includes(String(item.value)));
                    }
                    const idleStart = lastIdleOrAlarm ? lastIdleOrAlarm.ts : dayjs().valueOf();
                    lockedIdleStartRef.current = idleStart;
                    console.log("[LOCKED_IDLE START] at", idleStart);
                    let previousReason = null;
                    const savedReason = localStorage.getItem("activeReason");
                    if (savedReason) {
                        try {
                            previousReason = JSON.parse(savedReason);
                        } catch {
                            previousReason = null;
                        }
                    }
                    openReasonSwal(idleStart, reasonsList2, previousReason);
                }
                if (checkRestore && locked) {
                    const savedIdleStart = localStorage.getItem("lockedIdleStartTime");
                    const savedReason = localStorage.getItem("activeReason");
                    if (savedIdleStart && savedReason) {
                        try {
                            const parsedReason = JSON.parse(savedReason);
                            lockedIdleStartRef.current = parseInt(savedIdleStart, 10);
                            activeReasonRef.current = parsedReason;
                            isLockedRef.current = true;
                            console.log("[RESTORE] Reopening Swal after refresh with saved reason");
                            openReasonSwal(lockedIdleStartRef.current, reasonsList2, parsedReason);
                        } catch (e) {
                            console.error("Failed to restore reason from localStorage:", e);
                        }
                    }
                }
                const prevStatus = prevStatusRef.current;
                if (prevStatus !== latestStatusText) {
                    console.log(`[refreshData] status changed ${prevStatus} -> ${latestStatusText}`);
                }
                if (IDLE_END_CODES.includes(String(latestStatus)) &&
                    lockedIdleStartRef.current &&
                    activeReasonRef.current) {
                    const endEvent = machineStatusArray.find(
                        item => IDLE_END_CODES.includes(String(item.value)) && item.ts >= lockedIdleStartRef.current
                    ) || latestSample;
                    if (endEvent) {
                        const idleEndTime = endEvent.ts;
                        const duration = Math.floor((idleEndTime - lockedIdleStartRef.current) / 1000);
                        const parsedShifts = generateShiftInstances(lockedIdleStartRef.current, idleEndTime, shifts);
                        const segments = splitIdleByShifts(lockedIdleStartRef.current, idleEndTime, parsedShifts);
                        for (const seg of segments) {
                            const payload = {
                                ts: seg.start,
                                values: {
                                    live_reason: {
                                        name: activeReasonRef.current.reason,
                                        code: activeReasonRef.current.code || "",
                                        mode: activeReasonRef.current.mode || "",
                                        category: activeReasonRef.current.category || "",
                                        idle_start: seg.start,
                                        idle_end: seg.end,
                                        idle_duration: Math.floor((seg.end - seg.start) / 1000),
                                    },
                                },
                            };
                            try {
                                await operatorTelemetry("DEVICE", deviceId, payload);
                            } catch (err) {
                                console.error("Error submitting locked idle end:", err);
                            }
                        }

                        console.log("[LOCKED_IDLE END] at", idleEndTime, "duration:", duration, "sec");
                        lockedIdleStartRef.current = null;
                        activeReasonRef.current = null;
                        isLockedRef.current = false;
                        localStorage.removeItem("lockedIdleStartTime");
                        localStorage.removeItem("activeReason");
                    }
                }

                prevStatusRef.current = latestStatusText;
            } catch (err) {
                console.error("Error refreshing telemetry/lock:", err);
            }
        };
        refreshData(true);
        const interval = setInterval(() => refreshData(false), 5000);
        return () => clearInterval(interval);
    }, [selectedMachine, deviceNameIdJson, reasonsList2]);

    const [reasonGroupOptions, setReasonGroupOptions] = useState([]);
    useEffect(() => {
        const customerId = getCustomerId();
        if (cleanCustomerId(customerId) != window._env_.GPLAST_CUSTOMER_ID) return;
        if (!selectedMachine || !deviceNameIdJson[selectedMachine]) return;
        const deviceId = deviceNameIdJson[selectedMachine];
        const openReasonSwal = (idleStart, reasonsList2, previousReason = null) => {
            if (isSwalOpenRef.current) return;
            isSwalOpenRef.current = true;
            const uniqueGroups = Array.from(
                new Set(reasonsList2.map(r => r.group).filter(g => g && g.trim() !== ""))
            );
            const hasGroups = uniqueGroups.length > 0;
            const allGroups = hasGroups
                ? [{ label: "All Groups", value: "all" }, ...uniqueGroups.map(g => ({ label: g, value: g }))]
                : [];
            const defaultGroup =
                previousReason && previousReason.group && uniqueGroups.includes(previousReason.group)
                    ? previousReason.group
                    : "all";
            const selectedReasonRef = { current: previousReason };
            const SwalContent = () => {
                const [group, setGroup] = React.useState(defaultGroup);
                const [reason, setReason] = React.useState(selectedReasonRef.current);
                const filteredReasons = React.useMemo(() => {
                    return group === "all" ? reasonsList2 : reasonsList2.filter(r => r.group === group);
                }, [group]);
                React.useEffect(() => {
                    selectedReasonRef.current = reason;
                }, [reason]);
                return (
                    <div style={{ display: "flex", flexDirection: "column", gap: 10, textAlign: "left", minHeight: 150 }}>
                        <p>Machine has been locked due to downhold threshold reached.</p>

                        {hasGroups && (
                            <>
                                <label>Select Group:</label>
                                <Autocomplete
                                    options={allGroups}
                                    value={allGroups.find(g => g.value === group)}
                                    onChange={(_, newValue) => {
                                        setGroup(newValue?.value || "all");
                                        setReason(null);
                                    }}
                                    getOptionLabel={(opt) => opt?.label || ""}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Group" variant="outlined" size="small" />
                                    )}
                                />
                            </>
                        )}

                        <label>Select Reason:</label>
                        <Autocomplete
                            options={filteredReasons}
                            value={reason}
                            onChange={(_, newValue) => setReason(newValue)}
                            getOptionLabel={(opt) => opt?.reason || ""}
                            renderInput={(params) => (
                                <TextField {...params} label="Reason" variant="outlined" size="small" />
                            )}
                        />
                    </div>
                );
            };

            Swal.fire({
                icon: "info",
                title: "Machine Locked",
                html: '<div id="swal-root"></div>',
                showConfirmButton: true,
                confirmButtonText: "Submit",
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    const container = document.getElementById("swal-root");
                    if (container) {
                        ReactDOMClient.createRoot(container).render(<SwalContent />);
                    }
                },
                preConfirm: () => {
                    if (!selectedReasonRef.current) {
                        Swal.showValidationMessage("Please select a reason");
                        return false;
                    }
                    return selectedReasonRef.current;
                },
            }).then((result) => {
                if (result.isConfirmed && result.value) {
                    const selectedReason = result.value;
                    activeReasonRef.current = selectedReason;
                    localStorage.setItem("lockedIdleStartTime", idleStart);
                    localStorage.setItem("activeReason", JSON.stringify(selectedReason));

                    Swal.fire({
                        icon: "question",
                        title: "Confirm Submission",
                        text: `You selected: ${selectedReason.reason}. Do you want to confirm?`,
                        showCancelButton: true,
                        confirmButtonText: "Yes, Submit",
                        cancelButtonText: "No, Go Back",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(async (confirmResult) => {
                        isSwalOpenRef.current = false;
                        if (confirmResult.isConfirmed) {
                            const payload = {
                                ts: idleStart,
                                values: {
                                    live_reason: {
                                        name: selectedReason.reason,
                                        code: selectedReason.code || "",
                                        mode: selectedReason.mode || "",
                                        category: selectedReason.category || "",
                                        group: selectedReason.group || null,
                                        idle_start: idleStart,
                                        idle_end: 0,
                                        idle_duration: 0,
                                    },
                                },
                            };
                            try {
                                await operatorTelemetry("DEVICE", deviceId, payload);
                                await operatorTelemetry("DEVICE", deviceId, { lock_status: "unlocked" });
                                isLockedRef.current = false;
                                Swal.fire({
                                    icon: "success",
                                    title: "Submitted!",
                                    text: "Reason submitted successfully.",
                                    timer: 1500,
                                    showConfirmButton: false,
                                });
                            } catch (err) {
                                Swal.fire({
                                    icon: "error",
                                    title: "Error",
                                    text: "Failed to submit reason. Please try again.",
                                });
                            }
                        } else {
                            openReasonSwal(idleStart, reasonsList2, selectedReason);
                        }
                    });
                } else {
                    isSwalOpenRef.current = false;
                }
            });
        };
        const refreshData = async (checkRestore = false) => {
            try {
                const data = await fetchTelemetry(deviceId);
                let machineStatusArray = data?.machine_status || [];
                if (!machineStatusArray.length) return;
                machineStatusArray = machineStatusArray.slice().sort((a, b) => b.ts - a.ts);
                const latestSample = machineStatusArray[0];
                const latestValue = String(latestSample?.value ?? "").trim();
                const latestStatus = parseInt(latestValue || "0", 10);
                const IDLE_START_CODES = ["0", "1", "2"];
                const IDLE_END_CODES = ["3", "4", "5", "100"];
                const latestStatusText = statusText(latestStatus).toLowerCase();
                const response = await getMachineLock("DEVICE", deviceId, { keys: "lock_status" });
                const lockValue = response?.lock_status?.[0]?.value || "";
                const locked = String(lockValue).toLowerCase() === "locked";
                if (!locked && isLockedRef.current) {
                    console.log("[refreshData] unlocking");
                    isLockedRef.current = false;
                    isSwalOpenRef.current = false;
                    Swal.close();
                }
                if (locked && !isLockedRef.current && !isSwalOpenRef.current) {
                    isLockedRef.current = true;
                    let lastIdleOrAlarm = null;
                    for (let i = 0; i < machineStatusArray.length - 1; i++) {
                        const current = machineStatusArray[i];
                        const next = machineStatusArray[i + 1];
                        if (IDLE_END_CODES.includes(String(next.value)) && IDLE_START_CODES.includes(String(current.value))) {
                            lastIdleOrAlarm = current;
                            break;
                        }
                    }
                    if (!lastIdleOrAlarm) {
                        lastIdleOrAlarm = machineStatusArray.find(item => IDLE_START_CODES.includes(String(item.value)));
                    }
                    const idleStart = lastIdleOrAlarm ? lastIdleOrAlarm.ts : dayjs().valueOf();
                    lockedIdleStartRef.current = idleStart;
                    let previousReason = null;
                    const savedReason = localStorage.getItem("activeReason");
                    if (savedReason) {
                        try {
                            previousReason = JSON.parse(savedReason);
                        } catch {
                            previousReason = null;
                        }
                    }
                    openReasonSwal(idleStart, reasonsList2, previousReason);
                }
                if (checkRestore && locked && !isSwalOpenRef.current) {
                    const savedIdleStart = localStorage.getItem("lockedIdleStartTime");
                    const savedReason = localStorage.getItem("activeReason");
                    if (savedIdleStart && savedReason) {
                        try {
                            const parsedReason = JSON.parse(savedReason);
                            lockedIdleStartRef.current = parseInt(savedIdleStart, 10);
                            activeReasonRef.current = parsedReason;
                            isLockedRef.current = true;
                            openReasonSwal(lockedIdleStartRef.current, reasonsList2, parsedReason);
                        } catch (e) {
                            console.error("Failed to restore reason:", e);
                        }
                    }
                }
                if (
                    IDLE_END_CODES.includes(String(latestStatus)) &&
                    lockedIdleStartRef.current &&
                    activeReasonRef.current
                ) {
                    const endEvent =
                        machineStatusArray.find(
                            item => IDLE_END_CODES.includes(String(item.value)) && item.ts >= lockedIdleStartRef.current
                        ) || latestSample;
                    if (endEvent) {
                        const idleEndTime = endEvent.ts;
                        const parsedShifts = generateShiftInstances(lockedIdleStartRef.current, idleEndTime, shifts);
                        const segments = splitIdleByShifts(lockedIdleStartRef.current, idleEndTime, parsedShifts);
                        for (const seg of segments) {
                            const payload = {
                                ts: seg.start,
                                values: {
                                    live_reason: {
                                        name: activeReasonRef.current.reason,
                                        code: activeReasonRef.current.code || "",
                                        mode: activeReasonRef.current.mode || "",
                                        category: activeReasonRef.current.category || "",
                                        group: activeReasonRef.current.group || null,
                                        idle_start: seg.start,
                                        idle_end: seg.end,
                                        idle_duration: Math.floor((seg.end - seg.start) / 1000),
                                    },
                                },
                            };
                            try {
                                await operatorTelemetry("DEVICE", deviceId, payload);
                            } catch (err) {
                                console.error("Error submitting locked idle segment:", err);
                            }
                        }
                        lockedIdleStartRef.current = null;
                        activeReasonRef.current = null;
                        isLockedRef.current = false;
                        isSwalOpenRef.current = false;
                        localStorage.removeItem("lockedIdleStartTime");
                        localStorage.removeItem("activeReason");
                    }
                }

                prevStatusRef.current = latestStatusText;
            } catch (err) {
                console.error("Error refreshing telemetry/lock:", err);
            }
        };
        refreshData(true);
        const interval = setInterval(() => refreshData(false), 5000);
        return () => clearInterval(interval);
    }, [selectedMachine, deviceNameIdJson, reasonsList2]);

    function generateShiftInstances(startEpoch, endEpoch, shifts) {
        const startTimeOfDay = dayjs(startEpoch).hour() * 60 + dayjs(startEpoch).minute();
        const earliestShiftStart = Math.min(
            ...shifts.map((s) => {
                const [h, m] = s.start_time.split(":").map(Number);
                return h * 60 + m;
            })
        );
        const latestShiftEnd = Math.max(
            ...shifts.map((s) => {
                const [h, m] = s.end_time.split(":").map(Number);
                return h * 60 + m;
            })
        );
        const needsPreviousDay = startTimeOfDay < earliestShiftStart;
        const needsNextDay = (dayjs(endEpoch).hour() * 60 + dayjs(endEpoch).minute()) > latestShiftEnd;
        const startDate = dayjs(startEpoch)
            .startOf("day")
            .subtract(needsPreviousDay ? 1 : 0, "day");
        const endDate = dayjs(endEpoch)
            .endOf("day")
            .add(needsNextDay ? 1 : 0, "day");
        const result = [];
        let currentDate = startDate;
        while (currentDate.valueOf() <= endDate.valueOf()) {
            shifts.forEach((shift) => {
                const [startH, startM, startS] = shift.start_time.split(":").map(Number);
                const [endH, endM, endS] = shift.end_time.split(":").map(Number);
                let startTs = currentDate
                    .add(shift.start_day - 1, "day")
                    .hour(startH)
                    .minute(startM)
                    .second(startS);
                let endTs = currentDate
                    .add(shift.end_day - 1, "day")
                    .hour(endH)
                    .minute(endM)
                    .second(endS);
                if (endTs.isBefore(startTs)) endTs = endTs.add(1, "day");

                if (endTs.valueOf() >= startEpoch && startTs.valueOf() <= endEpoch) {
                    result.push({
                        shift_no: shift.shift_no,
                        startTs: startTs.valueOf(),
                        endTs: endTs.valueOf(),
                    });
                }
            });
            currentDate = currentDate.add(1, "day");
        }
        return result;
    }

    useEffect(() => {
        if (!operators.length) return;
        if (!telemetry.liveOperatorCode) {
            setSelectedOperator("");
            return;
        }
        const found = operators.find(
            op => String(op.id) === String(telemetry.liveOperatorCode)
        );
        if (found) {
            setSelectedOperator(found.id);
        } else {
            setSelectedOperator("");
        }
    }, [telemetry.liveOperatorCode, operators]);

    useEffect(() => {
        if (!currentShift) return;
        const code = telemetry?.liveComponent?.code || '';
        if (!code) {
            setLiveCompSelected('');
            return;
        }
        // Only auto-select if the component belongs to the current shift
        const compStartTime = telemetry.liveComponent?.start_time;
        const { shiftStart, shiftEnd } = getShiftEpoch(currentShift.start_time, currentShift.end_time);
        if (!compStartTime || compStartTime < shiftStart || compStartTime > shiftEnd) {
            setLiveCompSelected('');
            return;
        }
        setLiveCompSelected(code);
        if (!prevLiveComp && telemetry.liveComponentTs) {
            const { plan_id, plan_no, unit_desc, type, line, machine_name, Cavity, Item, ItemDesc, PlanQty, name, code: compCode, start_time, end_time, duration, cycle_time, handling_time, setup_time, factorval, factor, ShiftDesc } = telemetry.liveComponent || {};
            setPrevLiveComp({
                plan_id,
                plan_no,
                unit_desc,
                type,
                line,
                machine_name,
                Cavity,
                Item,
                ItemDesc,
                PlanQty,
                name,
                code: compCode,
                start_time,
                end_time,
                duration,
                cycle_time,
                handling_time,
                setup_time,
                factorval,
                factor,
                ShiftDesc,
                ts: telemetry.liveComponentTs,
            });
        }
    }, [telemetry.liveComponent, currentShift]);

    const cancelreason = async () => {
        setopenDownTimeModal(false);
    }

    const handleSaveThreshold2 = async () => {
        try {
            const completedRows = filteredResult.filter(item => item.reasonselected);
            if (completedRows.length === 0) {
                Swal.fire('Warning', 'No reasons selected to save.', 'warning');
                return;
            }
            for (const item of completedRows) {
                const operator = reasonslist.find(op => op.reason === item.reasonselected);
                const code = operator ? operator.code : null;
                const mode = operator ? operator.mode : null;
                const category = operator ? operator.category : null;
                const key = {
                    ts: item.start,
                    values: {
                        live_reason: {
                            name: item.reasonselected,
                            code: code,
                            mode: mode,
                            category: category,
                            idle_start: item.start,
                            idle_end: item.end,
                            idle_duration: item.duration
                        }
                    }
                };
                await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', key);
                setDeviceThresholds(prev => ({
                    ...prev,
                    [selectedDeviceId.id || selectedDeviceId]: item.reasonselected
                }));
            }
            Swal.fire({
                icon: "success",
                title: "Success",
                text: 'Reasons assigned successfully.',
                timer: 1500,
                showConfirmButton: false,
            });

        } catch (err) {
            console.error('Update error:', err);
            Swal.fire('Error', 'Failed to assign reason.', 'error');
        } finally {
            setopenDownTimeModal(false);
        }
    };

    const handleReasonChange = (index, val) => {
        setfilteredResult(prevResults => {
            const updatedResults = [...prevResults];
            updatedResults[index] = {
                ...updatedResults[index],
                reasonselected: val
            };
            return updatedResults;
        });
    };

    const getEpochFromShift2 = (shiftNo, selectedDateObj, shifts) => {
        if (!shiftNo || !selectedDateObj || !shifts || shifts.length === 0) {
            return { fromEpoch: null, toEpoch: null };
        }
        const selectedShiftData = shifts.find(shift => String(shift.shift_no) === String(shiftNo));
        if (!selectedShiftData) {
            return { fromEpoch: null, toEpoch: null };
        }
        const dateStr = selectedDateObj.format("YYYY-MM-DD");
        const startDateTime = dayjs(`${dateStr}T${selectedShiftData.start_time}`);
        let endDateTime;
        if (selectedShiftData.end_day !== selectedShiftData.start_day) {
            const nextDay = selectedDateObj.add(1, "day").format("YYYY-MM-DD");
            endDateTime = dayjs(`${nextDay}T${selectedShiftData.end_time}`);
        } else {
            endDateTime = dayjs(`${dateStr}T${selectedShiftData.end_time}`);
        }
        return {
            fromEpoch: startDateTime.valueOf(),
            toEpoch: endDateTime.valueOf(),
        };
    };

    useEffect(() => {
        if (
            location.pathname !== "/wP7n_AqZ9-rtY4X8jvS2T6eK0uL3MhQxGdN5oRc~1fHbJiV" &&
            location.pathname !== "/smc_operator_bf9tz" &&
            location.pathname !== "/marks_operator_ch8st" &&
            location.pathname !== "/makino_operator_av5tc" &&
            location.pathname !== "/gplast_operator_awe6tc" &&
            location.pathname !== "/demo_operator_av3tc" &&
            location.pathname !== "/atech_operator_atc67" &&
            location.pathname !== "/operator_screen_biotek" &&
            location.pathname !== "/operator_screen"
        ) {
            return;
        }
        const init = async () => {
            try {
                const secondUsername = window._env_.TENANT_GMAIL;
                const secondPassword = window._env_.TENANT_PASSWORD;
                const secondResponse = await Loginapi(secondUsername, secondPassword);
                localStorage.setItem("email1", secondUsername);
                localStorage.setItem("token1", secondResponse.token);
                localStorage.setItem("refreshToken1", secondResponse.refreshToken);
                localStorage.setItem("Companyname1", secondResponse.Companyname);
                localStorage.setItem("role_name1", secondResponse.Role);
                startTokenAutoRefresh();
                await fetchDevices();
            } catch (err) {
                console.error("Init failed", err);
            }
        };
        init();
    }, [location.pathname]);

    // Reset blue card notifications when component changes
    useEffect(() => {
        const currentCode = telemetry?.liveComponent?.code || telemetry?.liveComponent?.name || null;
        if (prevComponentCodeRef.current !== null && prevComponentCodeRef.current !== currentCode) {
            setBlueCardNotifications([]);
        }
        prevComponentCodeRef.current = currentCode;
    }, [telemetry.liveComponent]);

    // When shift changes, close running component with shift end_time, then reset fresh
    useEffect(() => {
        if (!currentShift || !isGplastCondition || !window._env_.GPLAST_DEVICE_IDS?.includes(deviceNameIdJson[selectedMachine])) return;
        const prev = prevShiftRef.current;
        prevShiftRef.current = currentShift;
        if (!prev || prev.shift_no === currentShift.shift_no) return;

        // Shift has crossed — immediately reset dropdown, then close out the running component
        setLiveCompSelected('');
        setPrevLiveComp(null);

        if (!prevLiveComp) return;
        const { shiftEnd } = getShiftEpoch(prev.start_time, prev.end_time);
        const deviceId = deviceNameIdJson[selectedMachine];
        if (!deviceId || !shiftEnd) return;

        const duration = Math.floor((shiftEnd - prevLiveComp.start_time) / 1000);
        const { ts: _shiftTs, ...prevLiveCompDataShift } = prevLiveComp;
        operatorTelemetry('DEVICE', deviceId, {
            ts: prevLiveComp.ts,
            values: {
                live_plan: {
                    ...prevLiveCompDataShift,
                    end_time: shiftEnd,
                    duration,
                }
            }
        })
            .catch(err => console.error('Error closing component on shift change:', err));
    }, [currentShift, isGplastCondition, selectedMachine, deviceNameIdJson]);

    // Click outside handler for notification dropdown
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (notifBellRef.current && !notifBellRef.current.contains(e.target)) {
                setShowBlueCardNotif(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setDate(dayjs().format("DD-MM-YYYY"));
            setTime(dayjs().format("HH:mm:ss"));
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const handleConfirm = () => {
        if (confirmType === "machine") {
            setSelectedMachine(pendingMachine);
            localStorage.setItem("selectedMachine", pendingMachine);
        } else if (confirmType === "operator") {
            setSelectedOperator(pendingOperator);
            postOperator(pendingOperator);
        }
        setConfirmType(null);
        setPendingMachine("");
        setPendingOperator("");
    };

    const handleCancel = () => {
        setConfirmType(null);
        setPendingMachine("");
        setPendingOperator("");
    };

    const postOperator = async (pendingOperator) => {
        try {
            const deviceId = deviceNameIdJson[selectedMachine];
            const startTime = dayjs().valueOf();
            const operatorName = operators.find(res => res.id == pendingOperator)?.name;

            if (currentOperator && currentOperator.start_time) {
                const updatedPrevOperator = {
                    ...currentOperator,
                    end_time: startTime,
                    duration: Math.floor((startTime - currentOperator.start_time) / 1000)
                };
                const prevPayload = {
                    ts: currentOperator.ts || dayjs().valueOf(),
                    values: { live_operator: updatedPrevOperator }
                };
                await operatorTelemetry('DEVICE', deviceId, prevPayload);
            }

            const newOperatorData = {
                name: operatorName,
                code: pendingOperator,
                start_time: startTime,
                end_time: 0,
                duration: 0,
                ts: startTime
            };

            const payload = {
                ts: startTime,
                values: {
                    live_operator: newOperatorData
                }
            };

            await operatorTelemetry('DEVICE', deviceId, payload);
            setCurrentOperator(newOperatorData);
            const payload2 = { ts: payload.ts, value: payload.values.live_operator };
            localStorage.setItem('operator_details', JSON.stringify(payload2));
        } catch (err) {
            console.error('operator api failure', err);
        }
    };

    const buildPlanLabel = (plan) => {
        // Support both `details` (array) and legacy `detail` (single object)
        const details = Array.isArray(plan?.details)
            ? plan.details
            : plan?.detail ? [plan.detail] : [];

        const isMachining = (plan?.type || plan?.Type || "").toLowerCase() === "machining";

        if (isMachining) {
            // Machining: label from Process[] → ProcessId & ProcessDesc
            const processParts = details.flatMap(detail =>
                (detail?.Process || []).map(p => `(${p.ProcessId} - ${p.ProcessDesc})`)
            );
            return `${plan.plan_no} - ${processParts.length ? processParts.map(p => `[ ${p} ]`).join(' , ') : '[]'}`;
        }

        // Non-Machining: existing logic using Item[]
        const detailParts = details.map(detail => {
            const items = detail?.Item || [];
            if (items.length === 1) {
                return `(${items[0].Item} - ${items[0].ItemDesc})`;
            }
            const ids = items.map(i => i.Item).join(' & ');
            const descs = items.map(i => i.ItemDesc).join(' & ');
            return `(${ids}) - (${descs})`;
        });
        return `${plan.plan_no} - ${detailParts.length ? detailParts.map(p => `[ ${p} ]`).join(' , ') : '[]'}`;
    };

    const buildDetailLabel = (plan, detail) => {
        const items = (detail?.Item || []).map(i => ({ id: i.Item, desc: i.ItemDesc }));
        const ids = items.map(i => i.id).filter(Boolean).join(' & ');
        const descs = items.map(i => i.desc).filter(Boolean).join(' & ');
        return `${plan.plan_no}: (${ids}) - (${descs})`;
    };

    const buildPlanCombinedLabel = (plan) => {
        const details = Array.isArray(plan?.details) ? plan.details : [];
        const items = details.flatMap(d => (d?.Item || []).map(i => ({ id: i.Item, desc: i.ItemDesc })));
        const ids = items.map(i => i.id).filter(Boolean).join(' & ');
        const descs = items.map(i => i.desc).filter(Boolean).join(' & ');
        return `${plan.plan_no}: (${ids}) - (${descs})`;
    };

    // selectedValue format: "PLANNO|DETAILIDX"
    const handleLiveComponentChange = async (selectedValue) => {
        if (!isGplastCondition || !window._env_.GPLAST_DEVICE_IDS?.includes(deviceNameIdJson[selectedMachine])) return;
        const [planNo, detailIdxStr] = (selectedValue || "").split("|");
        const detailIdx = parseInt(detailIdxStr, 10);
        const planList = Array.isArray(currentMachinePlan) ? currentMachinePlan : [];
        const selectedPlan = planList.find(p => p.plan_no === planNo);
        const planDetails = Array.isArray(selectedPlan?.details) ? selectedPlan.details : [];
        const selectedDetail = planDetails[detailIdx];
        if (!selectedPlan || !selectedDetail) return;

        const detailLabel = buildDetailLabel(selectedPlan, selectedDetail);
        const selectedComp = { name: detailLabel, code: selectedValue };

        const deviceId = deviceNameIdJson[selectedMachine];
        const now = Date.now();
        const { shiftStart, shiftEnd } = getShiftEpoch(currentShift?.start_time, currentShift?.end_time);

        // Build live_component entry from selected detail's items
        const allItems = Array.isArray(selectedDetail?.Item) ? selectedDetail.Item : [];
        const itemIds = allItems.map(i => i.Item).join(' & ');
        const itemDescs = allItems.map(i => i.ItemDesc).join(' & ');
        const totalPlanQty = allItems.reduce((sum, i) => sum + (Number(i.PlanQty) || 0), 0);
        const cavities = allItems.map(i => i.Cavity ?? null);
        const totalCavity = cavities.reduce((sum, c) => sum + (Number(c) || 0), 0);

        const liveComponentEntry = {
            plan_id: selectedPlan?.id ?? selectedPlan?.plan_id ?? '-',
            plan_no: selectedPlan?.plan_no,
            unit_desc: selectedPlan?.unit_desc ?? '-',
            type: selectedPlan?.type ?? selectedPlan?.Type ?? '-',
            line: selectedDetail?.line ?? '-',
            machine_name: selectedDetail?.machine_name ?? selectedMachine ?? '-',
            Cavity: cavities,
            Item: itemIds,
            ItemDesc: itemDescs,
            PlanQty: totalPlanQty,
            name: itemDescs,
            code: itemIds,
            start_time: now,
            end_time: shiftEnd,
            duration: Math.floor((shiftEnd - now) / 1000),
            cycle_time: selectedDetail?.CycleTime
                ? `${String(selectedDetail.CycleTime.Hours ?? 0).padStart(2, '0')}:${String(selectedDetail.CycleTime.Minutes ?? 0).padStart(2, '0')}:${String(selectedDetail.CycleTime.Seconds ?? 0).padStart(2, '0')}`
                : "00:00:00",
            handling_time: "00:00:00",
            setup_time: "00:00:00",
            factorval: totalCavity || '-',
            factor: "Multiplication Factor",
        };

        try {
            if (!liveCompSelected) {
                const noOpsEntry = {
                    name: 'No Operations',
                    code: '',
                    start_time: shiftStart,
                    end_time: now,
                    duration: Math.floor((now - shiftStart) / 1000),
                    cycle_time: "00:00:00",
                    handling_time: "00:00:00",
                    setup_time: "00:00:00",
                    factorval: 1,
                    factor: "Multiplication Factor",
                    ShiftDesc: currentShift?.shift_name || 'SHIFT1',
                };
                await operatorTelemetry('DEVICE', deviceId, {
                    ts: shiftStart,
                    values: {
                        live_plan: noOpsEntry,
                        live_component: noOpsEntry,
                    }
                });
            } else if (prevLiveComp) {
                const duration = Math.floor((now - prevLiveComp.start_time) / 1000);
                const { ts: _ts, ...prevLiveCompData } = prevLiveComp;
                await operatorTelemetry('DEVICE', deviceId, {
                    ts: prevLiveComp.ts,
                    values: {
                        live_plan: {
                            ...prevLiveCompData,
                            end_time: now,
                            duration,
                        },
                        live_component: {
                            ...prevLiveCompData,
                            end_time: now,
                            duration,
                        }
                    }
                });
            }

            const newEntry = {
                ...liveComponentEntry,
                start_time: now,
                end_time: shiftEnd,
                duration: Math.floor((shiftEnd - now) / 1000),
                ShiftDesc: currentShift?.shift_name || 'SHIFT1',
            };

            await operatorTelemetry('DEVICE', deviceId, {
                ts: now,
                values: {
                    live_plan: newEntry,
                    live_component: { ...liveComponentEntry, ShiftDesc: currentShift?.shift_name || 'SHIFT1' },
                }
            });

            setPrevLiveComp({ ...liveComponentEntry, ts: now });
            setLiveCompSelected(selectedValue);

            Swal.fire({
                title: 'Success',
                text: `Component changed to "${selectedComp.name}" successfully.`,
                icon: 'success',
                timer: 2000,
                showConfirmButton: false,
            });
        } catch (error) {
            console.error('Error changing component:', error);
            Swal.fire('Error', 'Failed to change component.', 'error');
        }
    };

    const formattedReasons = reasons.map(reason => ({
        ...reason,
        label: reason.label
    }));

    const handleConfirmAlert = () => {
        const operator = operators.find((o) => o.id === pendingOperator);
        if (confirmType === "operator" && !operator) return;
        Swal.fire({
            title: "Confirm Change",
            text:
                confirmType === "machine"
                    ? `Are you sure you want to change the machine to "${pendingMachine}"?`
                    : `Are you sure you want to change the operator to "${operator.id} - ${operator.name}"?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#F99022",
            cancelButtonColor: "#6b7280",
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                handleConfirm();
            } else {
                handleCancel();
            }
        });
    };

    const handleRejectParts = async () => {
        setSelectedRow({
            machineName: selectedMachine,
            op: {
                goodvsexp: `${telemetry.totalShots}/0`,
                operation_name: telemetry.jobName || "No Operations",
            },
        });
        setExistingCount(telemetry.scrap || 0);
        setRejectRows([{ count: 0, reason: [], remark: "", isExisting: false }]);
        setIsFetchingBluecard(false);
        setPrevOperatorData(null);
        setOpenReject(true);

        const deviceId = deviceNameIdJson[selectedMachine];

        // Fetch operations for current shift to get actual (goodvsexp numerator) and rejected counts
        if (deviceId && currentShift) {
            try {
                const { shiftStart, shiftEnd } = getShiftEpoch(currentShift.start_time, currentShift.end_time);
                const opsData = await telemetrykeydata(deviceId, "DEVICE", "operations", shiftStart, shiftEnd);
                const rawOps = opsData?.operations || [];
                const parsedOps = rawOps
                    .map(item => {
                        try {
                            const v = typeof item.value === "string" ? JSON.parse(item.value) : item.value;
                            return { ts: item.ts, ...v };
                        } catch { return null; }
                    })
                    .filter(Boolean);

                if (parsedOps.length > 0) {
                    parsedOps.sort((a, b) => b.ts - a.ts);
                    const latestOp = parsedOps[0];
                    const actualFromOps = Number((latestOp.goodvsexp?.split("/") || [])[0] || 0);
                    const rejectedFromOps = Number(latestOp.rejected ?? 0);
                    setSelectedRow({
                        machineName: selectedMachine,
                        op: {
                            goodvsexp: latestOp.goodvsexp || `${actualFromOps}/0`,
                            operation_name: telemetry.jobName || "No Operations",
                        },
                    });
                    setExistingCount(rejectedFromOps);
                }
            } catch (err) {
                console.warn("Could not fetch operations data for reject parts", err);
            }
        }

        const startTime = telemetry?.liveComponent?.start_time;
        if (deviceId && startTime) {
            try {
                const existingData = await telemetrykeydata(deviceId, "DEVICE", "rejection", startTime - 1000, startTime + 1000);
                const entries = existingData?.rejection || [];
                if (entries.length > 0) {
                    let parsed = null;
                    try { parsed = typeof entries[0].value === "string" ? JSON.parse(entries[0].value) : entries[0].value; } catch { }
                    if (parsed && Number(parsed.operator_count || 0) > 0) {
                        setPrevOperatorData({
                            count: Number(parsed.operator_count || 0),
                            reason: Array.isArray(parsed.operator_reason) ? parsed.operator_reason : parsed.operator_reason ? [parsed.operator_reason] : [],
                            remark: Array.isArray(parsed.operator_remark) ? parsed.operator_remark.join(", ") : parsed.operator_remark || "",
                        });
                    }
                }
            } catch (err) {
                console.warn("Could not fetch previous operator rejection data", err);
            }
        }
    };

    const formatReason = (val) => {
        if (!val) return "-";
        if (Array.isArray(val)) return val.map(v => String(v).trim()).filter(Boolean).join(", ");
        return String(val);
    };
    const isGplast = cleanCustomerId(customerId1) === window._env_.GPLAST_CUSTOMER_ID;


    const handleLoginAndFetch = async (machineName,
        formattedDate,
        selectedShift,
        isLiveShift) => {
        try {
            const loginRes = await getReportToken(
                isGplast ? "gd" : "pmi",
                isGplast ? "gd" : "pmi"
            );
            const token = loginRes?.accessToken;
            if (!token) {
                console.warn("Token missing — skipping report call");
                return;
            }
            await getReportGenerate1(
                machineName,
                formattedDate,
                selectedShift,
                isLiveShift
            );
        } catch (err) {
            console.error("Login/report flow failed:", err);
        }
    };

    const handleSave = async () => {

        const filledRows = rejectRows.filter(
            row => !row.isExisting && (Number(row.count) || 0) > 0
        );

        if (filledRows.length === 0) return;

        const newCount = filledRows.reduce((sum, row) => sum + Number(row.count), 0);

        const newReasons = filledRows
            .flatMap(row => Array.isArray(row.reason) ? row.reason : [row.reason])
            .filter(Boolean);

        const newRemarks = filledRows
            .map(row => row.remark)
            .filter(Boolean);

        const deviceId = deviceNameIdJson[selectedMachine];
        const startTime = telemetry?.liveComponent?.start_time;

        if (!deviceId || !startTime) {
            Swal.fire("Error", "No active component found.", "error");
            return;
        }

        /* -------------------------------
           Existing Values
        --------------------------------*/

        let prevEmails = [];

        let prevOperatorCount = 0;
        let prevOperatorReasons = [];
        let prevOperatorRemarks = [];

        let prevQualityCount = 0;
        let prevQualityReason = [];
        let prevQualityRemark = [];
        let prevQualityRows = [];

        let prevCount = 0;
        let prevReasons = [];
        let prevRemarks = [];

        try {

            const existingData = await telemetrykeydata(
                deviceId,
                "DEVICE",
                "rejection",
                startTime - 1000,
                startTime + 1000
            );

            const entries = existingData?.rejection || [];

            if (entries.length > 0) {

                let parsed = null;

                try {
                    parsed = typeof entries[0].value === "string"
                        ? JSON.parse(entries[0].value)
                        : entries[0].value;
                } catch { }

                if (parsed) {

                    prevEmails = Array.isArray(parsed.operator_email)
                        ? parsed.operator_email
                        : parsed.operator_email
                            ? [parsed.operator_email]
                            : [];

                    prevOperatorCount = Number(parsed.operator_count || 0);

                    prevOperatorReasons = Array.isArray(parsed.operator_reason)
                        ? parsed.operator_reason
                        : parsed.operator_reason
                            ? [parsed.operator_reason]
                            : [];

                    prevOperatorRemarks = Array.isArray(parsed.operator_remark)
                        ? parsed.operator_remark
                        : parsed.operator_remark
                            ? [parsed.operator_remark]
                            : [];

                    prevQualityCount = Number(parsed.qualitycount || 0);

                    prevQualityReason = Array.isArray(parsed.qualityreason)
                        ? parsed.qualityreason
                        : parsed.qualityreason
                            ? [parsed.qualityreason]
                            : [];

                    prevQualityRemark = Array.isArray(parsed.quality_remark)
                        ? parsed.quality_remark
                        : parsed.quality_remark
                            ? [parsed.quality_remark]
                            : [];

                    prevQualityRows = Array.isArray(parsed.quality_rows)
                        ? parsed.quality_rows
                        : [];

                    prevCount = Number(parsed.count || 0);

                    prevReasons = Array.isArray(parsed.reason)
                        ? parsed.reason
                        : parsed.reason
                            ? [parsed.reason]
                            : [];

                    prevRemarks = Array.isArray(parsed.remark)
                        ? parsed.remark
                        : parsed.remark
                            ? [parsed.remark]
                            : [];
                }
            }

        } catch (err) {
            console.warn("Could not fetch existing rejection data", err);
        }

        /* -------------------------------
           Correct Merging Logic
        --------------------------------*/

        const combinedEmails = [
            ...new Set([...prevEmails, CustomerEmail])
        ];

        const operatorCount = prevOperatorCount + newCount;

        const operatorReasons = [
            ...new Set([...prevOperatorReasons, ...newReasons])
        ];

        const operatorRemarks = [
            ...prevOperatorRemarks,
            ...newRemarks
        ];

        const totalCount = prevCount + newCount;

        const finalReasons = [
            ...new Set([...prevReasons, ...newReasons])
        ];

        const finalRemarks = [
            ...prevRemarks,
            ...newRemarks
        ];

        /* -------------------------------
           Payload
        --------------------------------*/

        const key = {
            ts: startTime,
            values: {
                rejection: {

                    operator_email: combinedEmails,
                    operator_count: operatorCount,
                    operator_reason: operatorReasons,
                    operator_remark: operatorRemarks,

                    qualitycount: prevQualityCount,
                    qualityreason: prevQualityReason,
                    quality_remark: prevQualityRemark,
                    quality_rows: prevQualityRows,

                    count: totalCount,
                    reason: finalReasons,
                    remark: finalRemarks,

                    shift: currentShift?.shift_no
                }
            }
        };

        try {

            await Downtimeadd1("DEVICE", deviceId, "SERVER_SCOPE", key);

            setOpenReject(false);
            setRejectRows([{ count: 0, reason: [], remark: "" }]);

            Swal.fire({
                icon: "success",
                title: "Success",
                text: `${newCount} part(s) rejected successfully.`,
                timer: 2000,
                showConfirmButton: false
            });
            const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
            const todayStr = dayjs().format("YYYY-MM-DD");
            const selectedDateStr = dayjs(selectedDate).format("YYYY-MM-DD");
            const currentShift = getCurrentShift(shifts);

            const isToday = selectedDateStr === todayStr;
            const isCurrentShift = String(selectedShift) === String(currentShift);
            const isLiveShift = isToday && isCurrentShift;

            await handleLoginAndFetch(selectedMachine,
                formattedDate,
                currentShift?.shift_no,
                "true")

        } catch (err) {

            console.error("Reject API failed:", err);

            Swal.fire(
                "Error",
                "Failed to reject parts. Try again.",
                "error"
            );
        }
    };

    const formatBlueCardTimer = (seconds) => {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    };

    useEffect(() => {
        if (!blueCardTimerStart) {
            setBlueCardElapsed(0);
            return;
        }
        const interval = setInterval(() => {
            setBlueCardElapsed(Math.floor((Date.now() - blueCardTimerStart) / 1000));
        }, 1000);
        return () => clearInterval(interval);
    }, [blueCardTimerStart]);

    const showBlueCardSuccess = () => {
        Swal.fire({
            title: "Success",
            text: "Blue Card has been pushed successfully",
            icon: "success",
            showConfirmButton: false, // remove OK button
            timer: 1500,               // 3 seconds
            timerProgressBar: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            width: "500px",
            customClass: {
                popup: "swal-wide"
            }
        });
    };


    const handleBlueCardPush = async (routeCardNo) => {
        if (!telemetry?.liveComponent?.name
        ) {
            console.warn("Blue card push skipped — missing component or shots");
            return;
        }
        showBlueCardSuccess();

        const operator = operators.find(
            op => String(op.id) === String(selectedOperator)
        );
        const payload = {
            job_name: telemetry.jobName || "",
            code: telemetry.jobCode || "",
            device_name: selectedMachine || "",
            clicked_ts: Date.now(),
            operator_name: operator?.name || "No Operator",
            component_starttime: telemetry?.liveComponent?.start_time,
            route_card_no: routeCardNo || "",
            total_shots: telemetry.totalShots ?? 0,
            target_parts: telemetry.targetParts ?? 0,
            shift: currentShift?.shift_no,

            status: "-",
            progress: "request",
        };

        setBlueCardLogs(prev => [...prev, payload]);

        blueCardTimerRef.current = payload.clicked_ts;
        setBlueCardTimerStart(payload.clicked_ts);
        setBlueCardElapsed(0);

        console.log("Stored in state:", payload);

        const customerId = getCustomerId();
        const deviceId = deviceNameIdJson[selectedMachine];

        const telemetryPayload = {
            ts: payload.clicked_ts,
            values: {
                bluecard_push: payload
            }
        };

        await operatorTelemetry(
            'CUSTOMER',
            customerId,
            telemetryPayload
        );

        try {
            const REQUEST_KEY = "request_payload";
            let existingRequests = [];
            try {
                const existing = await customerbasedshift(customerId, REQUEST_KEY);
                const val = existing[0]?.value;
                existingRequests = Array.isArray(val) ? val : [];
            } catch {
                existingRequests = [];
            }
            const updatedRequests = [...existingRequests, payload];
            await shiftadd(
                { [REQUEST_KEY]: updatedRequests, lastUpdateTs: Date.now() },
                customerId,
                "SERVER_SCOPE"
            );
            console.log("request_payload saved:", updatedRequests);
        } catch (err) {
            console.error("Failed to save request_payload:", err);
        }
    };

    useEffect(() => {
        const fetchRequestPayload = async () => {
            try {
                const customerId = getCustomerId();
                const result = await customerbasedshift(customerId, "request_payload");
                const val = result[0]?.value;
                setRequestPayload(Array.isArray(val) ? val : []);
            } catch (err) {
                console.error("request_payload fetch failed:", err);
                setRequestPayload([]);
            }
        };

        fetchRequestPayload();
        const poll = setInterval(fetchRequestPayload, 5000);
        return () => clearInterval(poll);
    }, []);

    useEffect(() => {
        const prev = prevRequestPayloadRef.current;
        const wasPending = prev.find(item => item.device_name === selectedMachine);
        const isStillPending = requestPayload.find(item => item.device_name === selectedMachine);

        if (wasPending && !isStillPending) {
            const fetchResponse = async () => {
                try {
                    const from = wasPending.clicked_ts - 1000;
                    const to = wasPending.clicked_ts + 1000;
                    const data = await telemetrykeydata(
                        cleanCustomerId(customerId1),
                        "CUSTOMER",
                        "bluecard_push",
                        from,
                        to
                    );
                    const entries = (data?.bluecard_push || [])
                        .map(p => {
                            try {
                                return typeof p.value === "string" ? JSON.parse(p.value) : p.value;
                            } catch { return null; }
                        })
                        .filter(e => e && e.device_name === wasPending.device_name && e.progress === "completed");

                    if (entries.length > 0) {
                        setBlueCardResponseData(entries[0]);
                        setOpenBlueCardResponse(true);
                        setBlueCardTimerStart(null);
                        setBlueCardElapsed(0);
                        blueCardTimerRef.current = null;
                    }
                } catch (err) {
                    console.error("Failed to fetch blue card response:", err);
                }
            };
            fetchResponse();
        }

        prevRequestPayloadRef.current = requestPayload;
    }, [requestPayload]);

    useEffect(() => {
        let blinkInterval;

        const hasPending = requestPayload.some(
            (item) => item.device_name === selectedMachine
        );

        if (hasPending) {
            setIsBlinking(true);
            setBlueCardText("Blue Card Pushed");

            blinkInterval = setInterval(() => {
                setIsBlinking((prev) => !prev);
            }, 500);
        } else {
            setIsBlinking(false);
            setBlueCardText("Blue Card Push");
        }

        return () => clearInterval(blinkInterval);
    }, [requestPayload, selectedMachine]);

    useEffect(() => {
        const machineData = requestPayload.find(
            item => item.device_name === selectedMachine
        );

        if (!machineData) {
            setBlueCardTimerStart(null);
            setBlueCardElapsed(0);
            return;
        }

        const startTime = machineData.clicked_ts;
        setBlueCardTimerStart(startTime);

        const interval = setInterval(() => {
            setBlueCardElapsed(
                Math.floor((Date.now() - startTime) / 1000)
            );
        }, 1000);

        return () => clearInterval(interval);
    }, [requestPayload, selectedMachine]);

    const showBlueCardConfirm = () => {
        Swal.fire({
            html: `
      <div style="text-align:center;padding:10px 10px;">
        <div
          style="
            width:80px;
            height:80px;
            border-radius:50%;
            border:4px solid #f4c7a1;
            display:flex;
            align-items:center;
            justify-content:center;
            margin:10px auto;
            color:#f4a261;
            font-size:40px;
            font-weight:bold;
          "
        >
          !
        </div>

        <p style="color:#000;margin-top:10px;font-size:20px;">
          Enter the Route Card No to push the Blue Card
        </p>

        <input
          id="routeCardInput"
          class="swal2-input"
          placeholder="Enter Route Card No"
          style="margin-top:10px;"
        />
      </div>
    `,
            showCancelButton: true,
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#f97316",
            cancelButtonColor: "#6b7280",
            allowOutsideClick: false,
            width: "420px",

            didOpen: () => {
                const input = document.getElementById("routeCardInput");
                const confirmBtn = Swal.getConfirmButton();

                confirmBtn.disabled = true;

                const validateInput = () => {
                    const value = input.value.trim();
                    const isValid = /^[a-z0-9 ]+$/i.test(value) && value.length > 0;
                    confirmBtn.disabled = !isValid;
                };

                input.addEventListener("input", validateInput);
                input.addEventListener("keyup", validateInput);
            },

            preConfirm: () => {
                const value = document.getElementById("routeCardInput").value.trim();
                return value;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                handleBlueCardPush(result.value);
                showBlueCardSuccess();
            }
        });
    };

    console.log('blue card data------------', blueCardLogs)
    console.log('selected shift', currentShift?.shift_no)
    console.log('selected shift no is', selectedShift)

    const blinkGreenBorder = keyframes`
  0%, 100% {
    box-shadow:
      inset 0 4px 0 0 rgba(21,128,61,0.9),
      inset -4px 0 0 0 rgba(21,128,61,0.9),
      inset 0 -4px 0 0 rgba(21,128,61,0.9),
      inset 4px 0 0 0 rgba(21,128,61,0.9),
      0 0 14px rgba(21,128,61,0.6);
  }
  50% {
    box-shadow:
      inset 0 4px 0 0 rgba(21,128,61,0.25),
      inset -4px 0 0 0 rgba(21,128,61,0.25),
      inset 0 -4px 0 0 rgba(21,128,61,0.25),
      inset 4px 0 0 0 rgba(21,128,61,0.25),
      0 0 6px rgba(21,128,61,0.25);
  }
`;

    /* ===== DARK RED ===== */
    const blinkRedBorder = keyframes`
  0%, 100% {
    box-shadow:
      inset 0 4px 0 0 rgba(185,28,28,0.9),
      inset -4px 0 0 0 rgba(185,28,28,0.9),
      inset 0 -4px 0 0 rgba(185,28,28,0.9),
      inset 4px 0 0 0 rgba(185,28,28,0.9),
      0 0 14px rgba(185,28,28,0.6);
  }
  50% {
    box-shadow:
      inset 0 4px 0 0 rgba(185,28,28,0.25),
      inset -4px 0 0 0 rgba(185,28,28,0.25),
      inset 0 -4px 0 0 rgba(185,28,28,0.25),
      inset 4px 0 0 0 rgba(185,28,28,0.25),
      0 0 6px rgba(185,28,28,0.25);
  }
`;

    const totalShotsNum = Number(telemetry?.totalShots || 0);

    const currentTimeTarget = (() => {
        if (!currentShift || !telemetry.targetParts) return 0;
        if (!telemetry.jobName || telemetry.jobName === "Route card not assigned") {
            return telemetry.targetParts;
        }
        const { shiftStart, shiftEnd } = getShiftEpoch(currentShift.start_time, currentShift.end_time);
        if (!shiftStart || !shiftEnd) return 0;
        const elapsed = Math.max(0, Date.now() - shiftStart);
        const totalDuration = shiftEnd - shiftStart;
        return Math.min(telemetry.targetParts, Math.round((elapsed / totalDuration) * telemetry.targetParts));
    })();

    // ATECH single-component Actual vs Target (current-time based):
    // actual = good count (goodvsexp numerator); target = elapsed ÷ cycle_time, capped at full exp.
    const atechComponentActual = (() => {
        const op = telemetry.operations;
        if (!op || !op.goodvsexp) return null;
        const [actualStr, expStr] = String(op.goodvsexp).split('/');
        const actual = parseInt(actualStr, 10) || 0;
        const fullExp = parseInt(expStr, 10) || 0;
        const [h = 0, m = 0, s = 0] = String(op.cycle_time || '').split(':').map(Number);
        const cycleSecs = (h * 3600) + (m * 60) + s;
        // Fall back to the backend's full exp when we can't prorate (no cycle time / no start / no exp).
        if (!op.start_time || cycleSecs <= 0 || fullExp <= 0) return { actual, target: fullExp };
        const elapsedSecs = Math.max(0, (Date.now() - op.start_time) / 1000);
        const target = Math.min(fullExp, Math.floor(elapsedSecs / cycleSecs));
        return { actual, target };
    })();

    const blueCardPushCount = blueCardLogs.filter(log => log.device_name === selectedMachine &&
        log.component === telemetry.jobName).length;
    const isBlueCardLimitReached = blueCardPushCount >= totalShotsNum && totalShotsNum != 0;
    console.log('telemetry', telemetry)

    const rejectActual = Number((selectedRow?.op?.goodvsexp?.split("/") || [])[0] || 0);
    const rejectAllowed = Math.max(0, rejectActual - (existingCount || 0));
    const totalNewRejectCount = rejectRows.reduce((sum, r) => !r.isExisting ? sum + Number(r.count || 0) : sum, 0);
    const isMaxReached = totalNewRejectCount >= rejectAllowed;
    const existingRows = rejectRows.filter(r => r.isExisting);

    const handleRejectParts1 = async (deviceId, initialCount = 0) => {
        let rejectCount = initialCount;
        await Swal.fire({
            title: "Reject Parts",
            html: `
      <div style="display:flex; align-items:center; justify-content:center; gap:30px;">
        <button id="decrement" 
          style="width:50px;height:50px;border-radius:50%;font-size:24px;font-weight:bold;background:#f56565;color:white;border:none;cursor:pointer;">-</button>
        <span id="counterValue" style="font-size:28px; font-weight:bold; min-width:50px; text-align:center;">${rejectCount}</span>
        <button id="increment" 
          style="width:50px;height:50px;border-radius:50%;font-size:24px;font-weight:bold;background:#48bb78;color:white;border:none;cursor:pointer;">+</button>
      </div>
    `,
            showCancelButton: true,
            confirmButtonText: "Continue",
            cancelButtonText: "Cancel",
            didOpen: () => {
                const counterEl = Swal.getHtmlContainer().querySelector("#counterValue");
                const incBtn = Swal.getHtmlContainer().querySelector("#increment");
                const decBtn = Swal.getHtmlContainer().querySelector("#decrement");
                const produced = telemetry.totalShots || 0;
                const alreadyRejected = telemetry.scrap || 0;
                const maxReject = produced - alreadyRejected;
                incBtn.addEventListener("click", () => {
                    if (rejectCount < maxReject) {
                        rejectCount++;
                        counterEl.textContent = rejectCount;
                    } else {
                        Swal.showValidationMessage(`Cannot exceed ${maxReject} parts`);
                    }
                });
                decBtn.addEventListener("click", () => {
                    if (rejectCount > 0) {
                        rejectCount--;
                        counterEl.textContent = rejectCount;
                    }
                });
            },
            preConfirm: () => {
                if (rejectCount <= 0) {
                    Swal.showValidationMessage("Please select at least 1 reject part");
                    return false;
                }
                return rejectCount;
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                const count = result.value;
                Swal.fire({
                    title: "Confirm Rejection",
                    text: `Are you sure you want to reject ${count} part(s)?`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Reject",
                    cancelButtonText: "No, Go Back",
                }).then(async (confirmResult) => {
                    if (confirmResult.isConfirmed) {
                        try {
                            const payload = { ts: dayjs().valueOf(), values: { rejection_id: count } };
                            await operatorTelemetry("DEVICE", deviceId, payload);
                            Swal.fire({
                                icon: "success",
                                title: "Success",
                                text: `${count} part(s) rejected successfully.`,
                                timer: 2000,
                                showConfirmButton: false,
                            });
                        } catch (err) {
                            console.error("Reject API failed:", err);
                            Swal.fire("Error", "Failed to reject parts. Try again.", "error");
                        }
                    } else if (confirmResult.dismiss === Swal.DismissReason.cancel) {
                        handleRejectParts1(deviceId, count);
                    }
                });
            }
        });
    };

    return (
        <div className="operator-screen" data-theme={isDark ? 'dark' : 'light'}>
            <div className="header">
                <img className="Logo" src={logo} alt="Logo" />
                <div className="header-text-element">
                    <h5>
                        <span className="span-1">Yantra </span>
                        <span className="span-2">Smart Buddy</span>
                    </h5>
                </div>
                <div className="calendar-container">
                    {/* header-right-group-clock anchor — date/time/theme pushed RIGHT via order:1 + marginLeft:auto */}
                    <div className="header-right-group-clock" style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginLeft: 'auto', order: 2 }}>
                    <div className="calendar">
                        <FaRegCalendarAlt className="icon" style={{ color: '#F99022' }} />
                        <p className='date-label'>{date}</p>
                    </div>

                    <div className="calendar">
                        <FaRegClock className='icon' style={{ color: '#F99022' }} />
                        <p className='date-label'>{time}</p>
                    </div>
                    <button className="theme-toggle" onClick={toggleTheme} title={isDark ? 'Switch to Light' : 'Switch to Dark'}>
                        {isDark ? <FaSun /> : <FaMoon />}
                    </button>
                    {isAtechCondition && (() => {
                        const url = window.location.origin + '/';
                        return (
                            <button
                                onClick={() => window.open(url, '_blank')}
                                title="Open Portal"
                                onMouseEnter={e => e.currentTarget.style.background = '#ea6c00'}
                                onMouseLeave={e => e.currentTarget.style.background = '#F99022'}
                                style={{
                                    background: '#F99022',
                                    border: 'none',
                                    borderRadius: '6px',
                                    padding: '6px 12px',
                                    cursor: 'pointer',
                                    color: '#fff',
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginLeft: '8px',
                                    transition: 'background 0.2s ease',
                                    boxShadow: '0 2px 6px rgba(249,144,34,0.4)',
                                    fontSize: '0.82rem',
                                    fontWeight: 700,
                                }}
                            >
                                <FaExternalLinkAlt size={13} style={{ marginRight: '6px' }} />
                                Setter Login
                            </button>
                        );
                    })()}
                    <div style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 8 }}>
                      <OperatorQueueButton
                        customerId={customerId1}
                        operator={identifiedOperator}
                        currentMachine={{ id: deviceNameIdJson[selectedMachine], name: selectedMachine }}
                        shiftName={currentShift?.shift_name || currentShift?.shift_no}
                        onRunningChange={setRunningWO}
                      />
                    </div>
                    {/* Smart Buddy view toggle */}
                    <div style={{ display:'inline-flex', background:'#fff', border:'1px solid #e5e7eb', borderRadius:10, padding:3, marginLeft:12 }}>
                      {[['efficiency','Efficiency'],['mes','MES Dashboard'],['report','Production Report']].map(([v,label])=>(
                        <button key={v} type="button" onClick={()=>setActiveView(v)} style={{ border:'none', cursor:'pointer', padding:'7px 14px', borderRadius:8, fontSize:12, fontWeight:700, background: activeView===v ? '#f97316' : 'transparent', color: activeView===v ? '#fff' : '#6b7280' }}>{label}</button>
                      ))}
                    </div>
                                        </div>{/* /header-right-group-clock */}
                    {/* === Clock In/Out widget (Phase 1 MES — added 2026-06-25) === */}
                    <div style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 12, order: 3 }}>
                        <ClockWidget
                            customerId={customerId1}
                            operator={identifiedOperator}
                            machineId={deviceNameIdJson[selectedMachine]}
                            machineName={selectedMachine}
                            shiftName={currentShift?.shift_name || currentShift?.shift_no}
                        />
                    </div>
                    {/* === Operator panel — grouped identity + brief + filter === */}
                    {identifiedOperator ? (
                        <div style={{
                            display: 'inline-flex', alignItems: 'stretch', order: 1,
                            marginLeft: 12, borderRadius: 10, overflow: 'hidden',
                            border: `1.5px solid ${myAssignedGroup ? '#16a34a' : '#f59e0b'}`,
                            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                        }}>
                            {/* Identity pill */}
                            <div
                                onClick={switchOperator}
                                title="Click to switch operator"
                                style={{
                                    display: 'inline-flex', alignItems: 'center', gap: 6,
                                    padding: '6px 12px',
                                    background: myAssignedGroup ? '#dcfce7' : '#fef3c7',
                                    color: myAssignedGroup ? '#14532d' : '#92400e',
                                    fontSize: 12, fontWeight: 700, cursor: 'pointer',
                                }}
                            >
                                <span style={{ fontSize: 14 }}>👤</span>
                                <span>{identifiedOperator.operatorname || identifiedOperator.name}</span>
                                {myAssignedGroup && (
                                    <span style={{
                                        background: '#16a34a', color: '#fff',
                                        padding: '1px 7px', borderRadius: 999,
                                        fontSize: 10, fontWeight: 800, marginLeft: 2,
                                    }}>{myAssignedGroup.machines.length}</span>
                                )}
                            </div>
                            {/* Pre-shift Checklist chip — always visible regardless of assignment */}
                            <button
                                onClick={() => setChecklistOpen(true)}
                                title={checklistDoneToday ? 'Pre-shift checklist completed' : 'Open pre-shift checklist'}
                                style={{
                                    display: 'inline-flex', alignItems: 'center', gap: 5,
                                    padding: '5px 11px', fontSize: 12, fontWeight: 700,
                                    background: checklistDoneToday ? '#dcfce7' : '#fef3c7',
                                    color: checklistDoneToday ? '#14532d' : '#92400e',
                                    border: '1px solid ' + (checklistDoneToday ? '#86efac' : '#fde68a'),
                                    borderRadius: 6, cursor: 'pointer',
                                    marginRight: 6,
                                }}
                            >
                                {checklistDoneToday ? '✓ Checklist' : '⚠ Checklist'}
                            </button>
                            {/* Brief button */}
                            {myAssignedGroup && (
                                <button
                                    onClick={() => setBriefingOpen(true)}
                                    title="View your shift briefing"
                                    style={{
                                        padding: '6px 11px', background: 'var(--y-bg, #fff)', color: '#4338ca',
                                        border: 'none', borderLeft: `1.5px solid ${myAssignedGroup ? '#16a34a' : '#f59e0b'}`,
                                        fontSize: 12, fontWeight: 700, cursor: 'pointer',
                                    }}
                                >📋 Brief</button>
                            )}
                            {/* Filter toggle */}
                            {myAssignedGroup && (
                                <button
                                    onClick={() => {
                                        const next = !filterToMyMachines;
                                        setFilterToMyMachines(next);
                                        localStorage.setItem('filter_to_my_machines', next ? '1' : '0');
                                    }}
                                    title={filterToMyMachines ? 'Showing only your machines — click to show all' : 'Showing all machines — click to filter to yours'}
                                    style={{
                                        padding: '6px 11px',
                                        background: filterToMyMachines ? '#16a34a' : '#fff',
                                        color: filterToMyMachines ? '#fff' : '#6b7280',
                                        border: 'none', borderLeft: `1.5px solid ${myAssignedGroup ? '#16a34a' : '#f59e0b'}`,
                                        fontSize: 12, fontWeight: 700, cursor: 'pointer',
                                    }}
                                >{filterToMyMachines ? '✓ Mine' : '⊞ All'}</button>
                            )}
                        </div>
                    ) : (
                        <button
                            onClick={() => setIdentifyModalOpen(true)}
                            style={{
                                marginLeft: 12, padding: '8px 16px',
                                background: '#F99022', color: '#fff', border: 'none',
                                borderRadius: 999, fontSize: 13, fontWeight: 700,
                                cursor: 'pointer', boxShadow: '0 2px 6px rgba(249,144,34,0.3)',
                            }}
                        >👤 Who are you?</button>
                    )}
                    {/* Blue Card Notification Bell */}
                    {isPMIBlueCardPage && (

                        <div ref={notifBellRef} style={{ position: 'relative', marginLeft: '16px', cursor: 'pointer' }}>
                            <div onClick={() => setShowBlueCardNotif(prev => !prev)} style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                <FaBell size={22} style={{ color: '#6b7280' }} />
                                {blueCardNotifications.length > 0 && (
                                    <span style={{
                                        position: 'absolute', top: -6, right: -6,
                                        background: '#F99022', color: 'white',
                                        borderRadius: '50%', width: 18, height: 18,
                                        fontSize: 11, fontWeight: 700,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        lineHeight: 1,
                                    }}>
                                        {blueCardNotifications.length}
                                    </span>
                                )}
                            </div>

                            {showBlueCardNotif && (
                                <div style={{
                                    position: 'absolute', top: '110%', right: 0, zIndex: 1100,
                                    background: t.bg, border: `1px solid ${t.border}`,
                                    borderRadius: '10px', boxShadow: isDark ? '0 8px 24px rgba(0,0,0,0.5)' : '0 8px 24px rgba(0,0,0,0.14)',
                                    minWidth: 320, maxHeight: 360, overflowY: 'auto',
                                }}>
                                    <div style={{ padding: '10px 16px', fontWeight: 700, fontSize: 14, borderBottom: `1px solid ${t.border}`, color: t.text }}>
                                        Blue Card Responses
                                        {telemetry?.liveComponent?.name && (
                                            <span style={{ fontWeight: 400, fontSize: 12, color: t.textSub, marginLeft: 8 }}>
                                                ({telemetry.liveComponent.name})
                                            </span>
                                        )}
                                    </div>
                                    {blueCardNotifications.length === 0 ? (
                                        <div style={{ padding: '24px 16px', textAlign: 'center', color: t.textSub, fontSize: 13 }}>
                                            No responses yet for this component
                                        </div>
                                    ) : (
                                        [...blueCardNotifications].reverse().map((n, i) => {
                                            const relTime = (() => {
                                                if (!n.receivedAt) return '';
                                                const diff = Math.floor((Date.now() - n.receivedAt) / 1000);
                                                if (diff < 60) return 'Just now';
                                                if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
                                                return `${Math.floor(diff / 3600)}h ago`;
                                            })();
                                            return (
                                                <div key={i} style={{
                                                    padding: '10px 16px', borderBottom: `1px solid ${t.border}`,
                                                    background: i === 0 ? t.bgRow : t.bg,
                                                    color: t.text,
                                                }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                                                        <span style={{ fontWeight: 600, fontSize: 14, color: n.status === 'OK' ? '#16a34a' : '#dc2626' }}>
                                                            {n.status === 'OK' ? '✓ Approved' : '✗ Rejected'} — {n.device_name || '-'}
                                                        </span>
                                                        <span style={{ fontSize: 11, color: t.textSub, whiteSpace: 'nowrap', marginLeft: 8 }}>
                                                            {relTime}
                                                        </span>
                                                    </div>
                                                    {n.status === 'NOK' && n.reason && (
                                                        <div style={{ fontSize: 12, color: t.text, marginBottom: 2 }}>
                                                            <strong>Reason:</strong> {Array.isArray(n.reason) ? n.reason.join(', ') : n.reason}
                                                        </div>
                                                    )}
                                                    {n.status === 'NOK' && n.remarks && n.remarks !== '-' && (
                                                        <div style={{ fontSize: 12, color: t.text }}>
                                                            <strong>Remark:</strong> {n.remarks}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                </div>
            </div>
            <div className="header-2" style={{ background: telemetry.machineColor }}>
                <div className="machine-name">
                    <p>Machine:</p>
                    {(() => {
                        const machineInfo = JSON.parse(localStorage.getItem("machineInfo"));
                        if (machineInfo?.machine_name && machineInfo?.machine_id) {
                            // Show only the stored machine
                            return (
                                <div style={{ color: "white", marginLeft: "0.5rem" }}>
                                    {machineInfo.machine_name}
                                </div>
                            );
                        } else {
                            // Show dropdown
                            return (
                                <FormControl
                                    size="small"
                                    variant="standard"
                                    sx={{
                                        minWidth: 120,
                                        marginLeft: "0.5rem",
                                        "& .MuiInputBase-root": { color: "white" },
                                        "& .MuiSvgIcon-root": { color: "white" },
                                        "& .MuiInput-underline:before": { borderBottom: "1px solid white" },
                                        "& .MuiInput-underline:hover:before": {
                                            borderBottom: "2px solid white",
                                        },
                                    }}
                                >
                                    <Select
                                        value={selectedMachine}
                                        onChange={(e) => {
                                            setPendingMachine(e.target.value);
                                            setConfirmType("machine");
                                        }}
                                    >
                                        {(filterToMyMachines && myAssignedMachineNames.length > 0
                                            ? machines.filter(m => myAssignedMachineNames.includes(m))
                                            : machines
                                        ).map((machine) => (
                                            <MenuItem key={machine} value={machine}>
                                                {machine}{myAssignedMachineNames.includes(machine) ? ' ✓' : ''}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            );
                        }
                    })()}

                </div>
                <div className="header-2-right">
                    <div className="machine-name">
                        <p>Status: {telemetry.machineStatus.charAt(0).toUpperCase() + telemetry.machineStatus.slice(1)}
                        </p>
                    </div>
                </div>
            </div>
            {/* === MY ROUND ring — directly under green machine status bar === */}
            {myAssignedGroup && myAssignedGroup.machines?.length > 1 && (
                <div style={{
                    display: 'flex', gap: 10, padding: '12px 20px', alignItems: 'center',
                    flexWrap: 'wrap',
                    background: 'linear-gradient(90deg, #fff7ed 0%, #ffedd5 100%)',
                    borderBottom: '2px solid #fed7aa',
                    boxShadow: 'inset 0 -1px 0 rgba(0,0,0,0.04)',
                }}>
                    <span style={{
                        fontSize: 12, fontWeight: 800, color: '#9a3412',
                        letterSpacing: 0.6, textTransform: 'uppercase',
                        display: 'inline-flex', alignItems: 'center', gap: 6,
                    }}>
                        <span style={{ fontSize: 16 }}>🎯</span> My Round
                    </span>
                    {myAssignedGroup.machines.map((m, idx) => {
                        const isActive = selectedMachine === m.name;
                        return (
                            <button
                                key={m.device_id}
                                onClick={() => {
                                    if (!isActive) {
                                        setPendingMachine(m.name);
                                        setConfirmType('machine');
                                    }
                                }}
                                style={{
                                    padding: '8px 16px', fontSize: 14, fontWeight: 700,
                                    background: isActive
                                        ? 'linear-gradient(180deg, #F99022 0%, #ea580c 100%)'
                                        : '#fff',
                                    color: isActive ? '#fff' : '#9a3412',
                                    border: `2px solid ${isActive ? '#F99022' : '#fed7aa'}`,
                                    borderRadius: 999, cursor: isActive ? 'default' : 'pointer',
                                    display: 'inline-flex', alignItems: 'center', gap: 8,
                                    boxShadow: isActive ? '0 2px 6px rgba(249,144,34,0.35)' : '0 1px 2px rgba(0,0,0,0.04)',
                                    transition: 'all 150ms ease',
                                    minHeight: 40,
                                }}
                            >
                                <span style={{
                                    width: 22, height: 22, borderRadius: '50%',
                                    background: isActive ? '#fff' : '#F99022',
                                    color: isActive ? '#F99022' : '#fff',
                                    fontSize: 12, fontWeight: 900,
                                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                }}>{idx + 1}</span>
                                <span>{m.name}</span>
                                {m.component_code && (
                                    <span style={{
                                        fontSize: 10, fontWeight: 600,
                                        opacity: isActive ? 0.85 : 0.6,
                                        padding: '1px 6px',
                                        background: isActive ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.05)',
                                        borderRadius: 3,
                                    }}>{m.component_code}</span>
                                )}
                                {isActive && (
                                    <span style={{
                                        fontSize: 10, fontWeight: 800, letterSpacing: 0.5,
                                        background: 'var(--y-bg, #fff)', color: '#F99022',
                                        padding: '2px 7px', borderRadius: 3,
                                    }}>HERE</span>
                                )}
                            </button>
                        );
                    })}
                </div>
            )}
            {isAtechCondition && deviceNameIdJson[selectedMachine] && currentShift && (() => {
                const { shiftStart, shiftEnd } = getShiftEpoch(currentShift.start_time, currentShift.end_time);
                if (!shiftStart || !shiftEnd) return null;
                const bearerToken = encodeURIComponent('Bearer+' + localStorage.getItem('token1'));
                const deviceId = deviceNameIdJson[selectedMachine];
                const grafanaUrl = window._env_.GRAFANA_URL;
                const serverUrl = window._env_.SERVER_URL;
                const iframeSrc = `${grafanaUrl}d/dfl4xwf27vp4we/machine-status-timeline?orgId=1&var-token=${bearerToken}&var-deviceId=${deviceId}&var-url=${serverUrl}&var-grafanaurl=${grafanaUrl}&from=${shiftStart}&to=now&theme=${isDark ? 'dark' : 'light'}&kiosk`;
                return (
                    <iframe
                        key={`grafana-mchstat-${currentShift.shift_no}-${selectedMachine}`}
                        src={iframeSrc}
                        style={{ display: 'block', width: '100%', height: '100px', border: 'none' }}
                        scrolling="no"
                        title="Machine Status Timeline"
                    />
                );
            })()}
            {/* === ACTION CASCADE — 3 columns: LEFT=AFTER NEXT (faded), CENTER=NEXT, RIGHT=NOW (biggest) === */}
            {/* action-cascade-3col */}
            {/* Phase 13 v4 2026-06-26: hide the AFTER-NEXT/NEXT/NOW action cards for PMI customer */}
            {(cleanCustomerId(customerId1) !== window._env_.CUSTOMER_ID) && (() => {
                const status = (telemetry?.machineStatus || '').toLowerCase();
                const partsMade = Number(telemetry?.parts?.made) || 0;
                const partsTarget = Number(telemetry?.parts?.target) || 0;
                const partsBehind = Math.max(0, partsTarget - partsMade);

                const TIER = {
                    r: { bg: '#fee2e2', border: '#dc2626', color: '#7a0000' },  // red
                    a: { bg: '#fef3c7', border: '#f59e0b', color: '#92400e' },  // amber
                    g: { bg: '#dcfce7', border: '#16a34a', color: '#14532d' },  // green
                    b: { bg: '#eff6ff', border: '#3b82f6', color: '#1e40af' },  // blue
                    n: { bg: '#f3f4f6', border: '#9ca3af', color: '#374151' },  // neutral
                };

                // [NOW, NEXT, AFTER_NEXT] — order is right-to-left in render
                let cascade;
                if (status === 'alarm') {
                    cascade = [
                        { tier: 'r', icon: '\u{1F6A8}', headline: 'INVESTIGATE ALARM', sub: 'Stop · check panel', pulse: true },
                        { tier: 'r', icon: '\u{1F527}', headline: 'CLEAR FAULT', sub: 'Reset alarm + verify cause' },
                        { tier: 'g', icon: '▶', headline: 'RESUME CYCLE', sub: 'Press CYCLE START' },
                    ];
                } else if (status === 'disconnected') {
                    cascade = [
                        { tier: 'r', icon: '\u{1F50C}', headline: 'CHECK CONNECTION', sub: 'Power · network cable', pulse: true },
                        { tier: 'a', icon: '\u{1F501}', headline: 'RECONNECT', sub: 'Reload Smart Buddy' },
                        { tier: 'g', icon: '▶', headline: 'RESUME PRODUCTION', sub: 'Continue cycle' },
                    ];
                } else if (status === 'idle' && partsBehind >= 3) {
                    cascade = [
                        { tier: 'a', icon: '\u{1F3C3}', headline: 'LOAD NEXT PART', sub: partsBehind + ' behind — move now', pulse: true },
                        { tier: 'g', icon: '▶', headline: 'START CYCLE', sub: 'Press CYCLE START' },
                        { tier: 'b', icon: '⚙', headline: 'MONITOR + PREP', sub: 'Stay ahead this time' },
                    ];
                } else if (status === 'idle' && partsBehind > 0) {
                    cascade = [
                        { tier: 'a', icon: '✋', headline: 'LOAD NEXT PART', sub: partsBehind + ' behind · pick pace' },
                        { tier: 'g', icon: '▶', headline: 'START CYCLE', sub: 'Press CYCLE START' },
                        { tier: 'b', icon: '⚙', headline: 'MONITOR CYCLE', sub: 'Watch progress' },
                    ];
                } else if (status === 'idle') {
                    cascade = [
                        { tier: 'b', icon: '▶', headline: 'READY TO START', sub: 'Load first part' },
                        { tier: 'g', icon: '⚙', headline: 'MONITOR CYCLE', sub: 'Watch + handle' },
                        { tier: 'b', icon: '\u{1F501}', headline: 'UNLOAD + RELOAD', sub: 'Prep next part' },
                    ];
                } else if (status === 'running' && partsBehind === 0 && partsTarget > 0) {
                    cascade = [
                        { tier: 'g', icon: '✓', headline: 'ON TRACK', sub: partsMade + ' / ' + partsTarget + ' done' },
                        { tier: 'b', icon: '\u{1F501}', headline: 'UNLOAD NEXT', sub: 'When cycle completes' },
                        { tier: 'b', icon: '✋', headline: 'LOAD FRESH PART', sub: 'Keep flow going' },
                    ];
                } else if (status === 'running' && partsBehind > 0) {
                    cascade = [
                        { tier: 'a', icon: '⏱', headline: 'RUNNING — WATCH PACE', sub: partsBehind + ' behind' },
                        { tier: 'b', icon: '\u{1F501}', headline: 'UNLOAD QUICKLY', sub: 'Cut handling time' },
                        { tier: 'b', icon: '✋', headline: 'LOAD IMMEDIATELY', sub: "Don't lose seconds" },
                    ];
                } else if (status === 'running') {
                    cascade = [
                        { tier: 'g', icon: '⚙', headline: 'PRODUCTION RUNNING', sub: 'Monitor cycle' },
                        { tier: 'b', icon: '\u{1F501}', headline: 'UNLOAD NEXT', sub: 'When cycle ends' },
                        { tier: 'b', icon: '✋', headline: 'LOAD FRESH PART', sub: 'Prep handling' },
                    ];
                } else {
                    cascade = [
                        { tier: 'n', icon: '\u{1F440}', headline: 'CHECK MACHINE', sub: 'Status unclear' },
                        { tier: 'n', icon: '\u{1F6E0}', headline: 'CALL SUPERVISOR', sub: 'If still unclear' },
                        { tier: 'n', icon: '⏸', headline: 'WAIT', sub: 'Pending guidance' },
                    ];
                }

                const [nowAct, nextAct, afterAct] = cascade;
                const card = (act, role) => {
                    const t = TIER[act.tier];
                    const isNow = role === 'now';
                    const isNext = role === 'next';
                    const sizeFactor = isNow ? 1 : (isNext ? 0.82 : 0.65);
                    const opacity = isNow ? 1 : (isNext ? 0.88 : 0.55);
                    return (
                        <div style={{
                            flex: isNow ? 1.7 : (isNext ? 1.25 : 1),
                            padding: isNow ? '18px 22px' : (isNext ? '14px 18px' : '12px 14px'),
                            background: t.bg,
                            border: (isNow ? '3px' : '2px') + ' solid ' + t.border,
                            borderRadius: 14,
                            display: 'flex', alignItems: 'center', gap: isNow ? 16 : 12,
                            opacity,
                            boxShadow: isNow ? '0 4px 12px rgba(0,0,0,0.08)' : '0 1px 4px rgba(0,0,0,0.04)',
                            animation: (isNow && act.pulse) ? 'guidance-pulse 1.4s ease-in-out infinite' : 'none',
                            transition: 'all 0.25s ease',
                            minWidth: 0,
                        }}>
                            <div style={{
                                width: 76 * sizeFactor, height: 76 * sizeFactor, borderRadius: '50%',
                                background: '#fff',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: 46 * sizeFactor,
                                boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                                flexShrink: 0,
                            }}>{act.icon}</div>
                            <div style={{ flexGrow: 1, minWidth: 0 }}>
                                <div style={{
                                    fontSize: 10, fontWeight: 800, color: t.color,
                                    letterSpacing: 1.4, marginBottom: 4,
                                }}>
                                    {isNow ? 'NOW → DO THIS' : (isNext ? 'NEXT' : 'AFTER NEXT')}
                                </div>
                                <div style={{
                                    fontSize: isNow ? 22 : (isNext ? 17 : 14),
                                    fontWeight: 900, color: t.color, lineHeight: 1.15,
                                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                                }}>
                                    {act.headline}
                                </div>
                                <div style={{
                                    fontSize: isNow ? 13 : (isNext ? 12 : 11),
                                    fontWeight: 600, color: t.color, marginTop: 3, opacity: 0.8,
                                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                                }}>
                                    {act.sub}
                                </div>
                            </div>
                        </div>
                    );
                };

                const arrow = (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center',
                                  color: '#9ca3af', fontSize: 28, fontWeight: 700, padding: '0 2px',
                                  userSelect: 'none' }}>
                        →
                    </div>
                );

                return (
                    <div style={{
                        margin: '14px 28px 8px',
                        display: 'flex', alignItems: 'stretch', gap: 8,
                    }}>
                        {card(afterAct, 'after')}
                        {arrow}
                        {card(nextAct, 'next')}
                        {arrow}
                        {card(nowAct, 'now')}
                        <style>{`
                            @keyframes guidance-pulse {
                                0%, 100% { box-shadow: 0 4px 12px rgba(0,0,0,0.08); }
                                50%      { box-shadow: 0 0 0 4px rgba(220,38,38,0.18), 0 4px 18px rgba(0,0,0,0.12); }
                            }
                        `}</style>
                    </div>
                );
            })()}

            <div className="content">
                <div className="contect-section" style={{ width: '10rem' }}>
                    <VerticalProgress
                        shiftNo={currentShift?.shift_no}
                        shiftStart={currentShift?.start_time}
                        shiftEnd={currentShift?.end_time}
                        firstActive={telemetry?.firstActive}
                    />
                </div>
                <div className="contect-section circular-progress-section">
                    <CircularProgress
                        actual={telemetry.totalShots}
                        target={isAtechCondition && currentTimeTarget > 0 ? currentTimeTarget : telemetry.targetParts}
                        partsBehind={Math.max(0, (isAtechCondition && currentTimeTarget > 0 ? currentTimeTarget : telemetry.targetParts) - telemetry.totalShots)}
                        partsRejects={telemetry.scrap}
                        status={telemetry.machineStatus}
                    />
                    {/* Hide the redundant bottom operator dropdown when identity is already shown
                        in the top header. Click the top "👤 [Name]" chip to switch. */}
                    <div className="username-section" style={identifiedOperator ? { display: 'none' } : {}}>
                        <FormControl
                            variant="standard"
                            sx={{
                                minWidth: 140,
                                "& .MuiInputBase-root": { color: "#f99022", fontWeight: 600 },
                                "& .MuiSvgIcon-root": { color: "#f99022" },
                            }}
                        >
                            <Select
                                value={operatorSearch ? "" : (selectedOperator || "")}
                                open={operatorMenuOpen}
                                onOpen={() => setOperatorMenuOpen(true)}
                                onClose={() => { setOperatorMenuOpen(false); setOperatorSearch(""); }}
                                onChange={(e) => {
                                    if (!e.target.value) return;
                                    setPendingOperator(e.target.value);
                                    setConfirmType("operator");
                                }}
                                MenuProps={{
                                    PaperProps: { className: "operator-select-menu" },
                                    autoFocus: false,
                                }}
                                displayEmpty
                                renderValue={() => {
                                    if (!selectedOperator) return <span style={{ color: "#f99022" }}>No operator assigned</span>;
                                    const operator = operators.find(op => String(op.id) === String(selectedOperator));
                                    return operator ? `${operator.id} - ${operator.name}` : "";
                                }}
                                disableUnderline
                            >
                                {isAtechCondition && (
                                    <MenuItem
                                        disableRipple
                                        onKeyDown={(e) => e.stopPropagation()}
                                        sx={{ p: 1, "&:hover": { background: "transparent" }, "&.Mui-focusVisible": { background: "transparent" } }}
                                    >
                                        <TextField
                                            size="small"
                                            placeholder="Search by ID or name…"
                                            value={operatorSearch}
                                            onChange={(e) => setOperatorSearch(e.target.value)}
                                            inputProps={{ "data-no-keyboard": true }}
                                            autoFocus
                                            fullWidth
                                            onClick={(e) => e.stopPropagation()}
                                            sx={{ "& .MuiInputBase-input": { fontSize: "0.85rem" } }}
                                        />
                                    </MenuItem>
                                )}
                                <MenuItem disabled value="">
                                    No operator assigned
                                </MenuItem>
                                {operators
                                    .filter(op => {
                                        if (!isAtechCondition) return true;
                                        const q = operatorSearch.toLowerCase();
                                        return !q || String(op.id).toLowerCase().includes(q) || op.name.toLowerCase().includes(q);
                                    })
                                    .map((op, idx) => (
                                        <MenuItem key={`${op.id}-${idx}`} value={op.id}>
                                            {op.id} - {op.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <div className="contect-section">
                    {isGplastCondition && window._env_.GPLAST_DEVICE_IDS?.includes(deviceNameIdJson[selectedMachine]) ? (
                        <div className="job-info">
                            <div className="component-section">
                                <FormControl
                                    variant="standard"
                                    sx={{
                                        minWidth: 120,
                                        "& .MuiInputBase-root": { color: "#444", fontWeight: 600, fontSize: "0.96rem" },
                                        "& .MuiSvgIcon-root": { color: "#888", fontSize: "1.1rem" },
                                    }}
                                >
                                    <Select
                                        value={liveCompSelected || ""}
                                        onChange={(e) => handleLiveComponentChange(e.target.value)}
                                        displayEmpty
                                        disableUnderline
                                        renderValue={(selected) => {
                                            if (!selected) {
                                                return <span style={{ color: "#aaa", fontWeight: 400 }}>No component</span>;
                                            }

                                            const [selPlanNo, selIdxStr] = (selected || "").split("|");
                                            const selIdx = parseInt(selIdxStr, 10);
                                            const planList = Array.isArray(currentMachinePlan) ? currentMachinePlan : [];
                                            const selPlan = planList.find(p => p.plan_no === selPlanNo);
                                            const selDetail = Array.isArray(selPlan?.details) ? selPlan.details[selIdx] : null;
                                            if (selPlan && selDetail) {
                                                return buildDetailLabel(selPlan, selDetail);
                                            }
                                            // plan list still loading — show stored label from telemetry
                                            const storedName = telemetry?.liveComponent?.name;
                                            if (storedName) return storedName;
                                            return <span style={{ color: "#aaa", fontWeight: 400 }}>No component</span>;
                                        }}
                                    >
                                        <MenuItem disabled value="">
                                            No component selected
                                        </MenuItem>
                                        {(Array.isArray(currentMachinePlan) ? [...currentMachinePlan] : [])
                                            .sort((a, b) => String(a.plan_no).localeCompare(String(b.plan_no), undefined, { numeric: true }))
                                            .flatMap((plan) =>
                                                (Array.isArray(plan?.details) ? plan.details : []).map((detail, dIdx) => (
                                                    <MenuItem key={`${plan.plan_no}|${dIdx}`} value={`${plan.plan_no}|${dIdx}`}>
                                                        {buildDetailLabel(plan, detail)}
                                                    </MenuItem>
                                                ))
                                            )}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                    ) : (

                        <div className="job-info">
                            {runningWO ? (
                                <>
                                    <p className="job-code" style={{ fontWeight: 800, color: '#16a34a', fontSize: 14, margin: 0 }}>
                                        ▶ {runningWO.wo_number} · {runningWO.op_seq}
                                    </p>
                                    <p className="job-name" style={{ fontWeight: 700, margin: '2px 0 0 0' }}>
                                        {runningWO.part_name || runningWO.op_name || '—'}
                                        {runningWO.part_number && (
                                            <span style={{ fontWeight: 600, color: '#6b7280', fontSize: 12 }}> · {runningWO.part_number}</span>
                                        )}
                                    </p>
                                    <p style={{ fontSize: 11, color: '#6b7280', margin: '2px 0 0 0' }}>
                                        Route card: <strong>{runningWO.wo_number}</strong>
                                    </p>
                                </>
                            ) : (
                                <>
                                    <p className="job-code">{telemetry.jobCode || ""}</p>
                                    <p className="job-name">{telemetry.jobName || "—"}</p>
                                </>
                            )}
                        </div>
                    )}

                    <div className="time-wrapper">
                        <div className="time-item">
                            <span>Cycle Time</span>
                            <p>{telemetry?.liveComponent?.cycle_time || "00:00:00"}</p>
                        </div>
                        <div className="time-item">
                            <span>Handling Time</span>
                            <p>{telemetry?.liveComponent?.handling_time || "00:00:00"}</p>
                        </div>
                    </div>

                    <div className="actual-wrapper">
                        <p className="actual-label">{isAtechCondition ? 'Actual vs Target (Current)' : 'Actual vs Target'}</p>
                        <p className="actual-value">
                            {isAtechCondition
                                ? (atechComponentActual
                                    ? `${atechComponentActual.actual}/${atechComponentActual.target}`
                                    : `${telemetry.totalShots ?? 0}/${telemetry.targetParts ?? 0}`)
                                : `${telemetry.totalShots ?? 0}/${telemetry.targetParts ?? 0}`}
                        </p>
                        {isAtechCondition && telemetry.targetParts > 0 && (
                            <>
                                <p className="actual-label" style={{ marginTop: '20px' }}>Actual vs Target (Overall)</p>
                                <p className="actual-value">
                                    {telemetry.totalShots ?? 0}/{telemetry.targetParts}
                                </p>
                            </>
                        )}
                    </div>

                    {/* Blue card button */}
                    {isPMIBlueCardPage && (
                        <div
                            className="button-wrapper"
                            style={{
                                padding: "12px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            <button
                                className={`blue-card-button ${isBlinking ? "blink" : ""}`}
                                style={{
                                    fontSize: "20px",
                                    cursor: (blueCardText === "Blue Card Pushed" || !telemetry.jobName || telemetry.jobName === "Route card not assigned")
                                        ? "not-allowed"
                                        : "pointer",
                                    opacity: (blueCardText === "Blue Card Pushed" || !telemetry.jobName || telemetry.jobName === "Route card not assigned") ? 0.7 : 1
                                }}
                                onClick={() => {
                                    if (
                                        blueCardText === "Blue Card Pushed" ||
                                        !telemetry.jobName ||
                                        telemetry.jobName === "Route card not assigned"
                                    ) {
                                        return;
                                    }

                                    // ⭐ IMPORTANT: show error when limit reached
                                    if (isBlueCardLimitReached) {
                                        Swal.fire({
                                            icon: "error",
                                            title: "Limit Reached",
                                            text: `Blue Card can only be pushed ${telemetry.totalShots} times.`,
                                            confirmButtonColor: "#d33",
                                        });
                                        return;
                                    }

                                    showBlueCardConfirm();
                                }}
                                disabled={
                                    blueCardText === "Blue Card Pushed" ||
                                    !telemetry.jobName ||
                                    telemetry.jobName === "Route card not assigned"
                                }
                            >
                                {blueCardText}
                            </button>

                            {blueCardTimerStart && (
                                <div
                                    style={{
                                        marginTop: "10px",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        color: "#cc5500",
                                    }}
                                >
                                    Waiting Time: {formatBlueCardTimer(blueCardElapsed)}
                                </div>
                            )}
                            <style jsx>{`
  .blue-card-button {
    position: relative;
    padding: 12px 24px;
    font-size: 16px;
    border-radius: 50px; /* pill shape */
    border: none;
    background-color: #007bff;
    color: white;
    cursor: pointer;
    z-index: 0;
    overflow: visible;
  }

  /* Ripple layers radiating outward */
  .blue-card-button.blink::before,
  .blue-card-button.blink::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    background-color: rgba(0, 123, 255, 0.4);
    z-index: -1;
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.7;
  }

  /* First layer */
  .blue-card-button.blink::before {
    animation: pulse1 2s infinite;
  }

  /* Second layer with staggered start and longer duration */
  .blue-card-button.blink::after {
    animation: pulse2 3s infinite;
  }

  @keyframes pulse1 {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 0.7;
    }
    70% {
      transform: translate(-50%, -50%) scale(2);
      opacity: 0;
    }
    100% {
      transform: translate(-50%, -50%) scale(2);
      opacity: 0;
    }
  }

  @keyframes pulse2 {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 0.6;
    }
    70% {
      transform: translate(-50%, -50%) scale(2.5);
      opacity: 0;
    }
    100% {
      transform: translate(-50%, -50%) scale(2.5);
      opacity: 0;
    }
  }
`}</style>
                        </div>
                    )}
                </div>

                <Dialog
                    open={openBlueCardConfirm}
                    onClose={() => setOpenBlueCardConfirm(false)}
                    PaperProps={{
                        sx: {
                            borderRadius: "8px",
                            padding: "10px 20px",
                            minWidth: "420px",
                            textAlign: "center",
                        },
                    }}
                >
                    <DialogContent>
                        <div
                            style={{
                                width: 80,
                                height: 80,
                                borderRadius: "50%",
                                border: "4px solid #f4c7a1",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "10px auto",
                                color: "#f4a261",
                                fontSize: 40,
                                fontWeight: "bold",
                            }}
                        >
                            !
                        </div>
                        <p style={{ color: "#555", marginBottom: 20, fontSize: "20px" }}>
                            Enter the Route Card No to push Blue Card
                        </p>

                        <div style={{ display: "flex", justifyContent: "center", gap: 12, fontSize: "14px" }}>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#f97316",
                                    padding: "10px 20px",
                                    "&:hover": { backgroundColor: "#ea580c" },
                                }}
                                onClick={() => {
                                    setOpenBlueCardConfirm(false);   // close confirm dialog
                                    handleBlueCardPush();            // push data
                                    setOpenBlueCardSuccess(true);    // open success dialog
                                }}
                            >
                                Confirm
                            </Button>

                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#6b7280",
                                    padding: "6px 20px",
                                    "&:hover": { backgroundColor: "#4b5563" },
                                }}
                                onClick={() => setOpenBlueCardConfirm(false)}
                            >
                                cancel
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={openBlueCardResponse} disableEscapeKeyDown
                    onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                            setOpenBlueCardResponse(false);
                        }
                    }}
                    PaperProps={{
                        sx: {
                            borderRadius: "12px",
                            minWidth: "380px",
                            textAlign: "center",
                            overflow: "hidden",
                            background: blueCardResponseData?.status === "OK" ? "#0b9348" : "#fd3f3f",
                        },
                    }}
                >

                    <DialogContent
                        sx={{
                            padding: "28px 32px 20px",
                            background: "var(--y-bg, #ffffff)",
                            textAlign: "center",

                            borderRadius: "12px",
                            animation:
                                blueCardResponseData?.status === "OK"
                                    ? `${blinkGreenBorder} 1.5s ease-in-out infinite`
                                    : `${blinkRedBorder} 1.5s ease-in-out infinite`,
                        }}
                    >
                        {/* Icon */}
                        <div
                            style={{
                                width: 80,
                                height: 80,
                                borderRadius: "50%",
                                background:
                                    blueCardResponseData?.status === "OK" ? "#16a34a" : "#dc2626",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "0 auto 16px",
                                color: "#fff",
                                fontSize: 40,
                                fontWeight: "bold",
                            }}
                        >
                            {blueCardResponseData?.status === "OK" ? "✓" : "✗"}
                        </div>

                        {/* Status heading */}
                        <h3
                            style={{
                                margin: "0 0 6px",
                                fontSize: "23px",
                                fontWeight: 700,
                                color:
                                    blueCardResponseData?.status === "OK" ? "#16a34a" : "#dc2626",
                            }}
                        >
                            {blueCardResponseData?.status === "OK"
                                ? "Blue Card Approved"
                                : "Blue Card Rejected"}
                        </h3>

                        {/* Machine */}
                        <p style={{ marginBottom: "6px", fontSize: "16px", color: "#374151" }}>
                            <strong>Machine:</strong>{" "}
                            <span
                                style={{
                                    color:
                                        blueCardResponseData?.status === "OK"
                                            ? "#16a34a"
                                            : "#dc2626",
                                    fontWeight: 600
                                }}
                            >
                                {blueCardResponseData?.device_name || "-"}
                            </span>
                        </p>

                        {/* Time */}
                        {blueCardResponseData?.end_time && (
                            <p style={{ marginBottom: "16px", fontSize: "14px", color: "#374151" }}>
                                at{" "}
                                <strong
                                    style={{
                                        color:
                                            blueCardResponseData?.status === "OK"
                                                ? "#16a34a"
                                                : "#dc2626",
                                    }}
                                >
                                    {new Date(blueCardResponseData.end_time).toLocaleTimeString(
                                        "en-IN",
                                        {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            second: "2-digit",
                                            hour12: true,
                                        }
                                    )}
                                </strong>
                            </p>
                        )}

                        {/* NOK details */}
                        {blueCardResponseData?.status === "NOK" && (
                            <div
                                style={{
                                    background: "var(--y-bg, #ffffff)",
                                    border:
                                        blueCardResponseData?.status === "OK"
                                            ? "1px solid #bbf7d0"
                                            : "1px solid #f04343",
                                    borderRadius: "8px",
                                    padding: "14px 16px",
                                    textAlign: "left",
                                    marginBottom: "16px",
                                }}
                            >
                                <p style={{ margin: "0 0 8px", fontSize: "14px", color: "#374151" }}>
                                    <strong>Reason:</strong>{" "}
                                    <span
                                        style={{
                                            color:
                                                blueCardResponseData?.status === "OK"
                                                    ? "#16a34a"
                                                    : "#dc2626",
                                            fontWeight: 600,
                                            wordBreak: "break-word",
                                            overflowWrap: "anywhere",
                                            whiteSpace: "normal",
                                        }}
                                    >
                                        {Array.isArray(blueCardResponseData?.reason)
                                            ? blueCardResponseData.reason.join(", ")
                                            : blueCardResponseData?.reason || "Not provided"}
                                    </span>
                                </p>

                                <p style={{ margin: 0, fontSize: "14px", color: "#374151" }}>
                                    <strong>Remark:</strong>{" "}
                                    <span
                                        style={{
                                            color:
                                                blueCardResponseData?.status === "OK"
                                                    ? "#16a34a"
                                                    : "#dc2626",
                                            fontWeight: 600,
                                            wordBreak: "break-word",
                                            overflowWrap: "anywhere",
                                            whiteSpace: "normal",
                                        }}
                                    >
                                        {blueCardResponseData?.remarks &&
                                            blueCardResponseData.remarks !== "-"
                                            ? blueCardResponseData.remarks
                                            : "Not provided"}
                                    </span>
                                </p>
                            </div>
                        )}

                        <Button
                            variant="contained"
                            sx={{
                                marginTop: 1,
                                backgroundColor:
                                    blueCardResponseData?.status === "OK" ? "#16a34a" : "#dc2626",
                                "&:hover": {
                                    backgroundColor:
                                        blueCardResponseData?.status === "OK" ? "#15803d" : "#b91c1c",
                                },
                                minWidth: 120,
                            }}
                            onClick={() => {
                                if (blueCardResponseData) {
                                    setBlueCardNotifications(prev => [...prev, { ...blueCardResponseData, receivedAt: Date.now() }]);
                                }
                                setOpenBlueCardResponse(false);
                            }}
                        >
                            OK
                        </Button>
                    </DialogContent>
                </Dialog>

            </div>
            <div className="footer1">
                <div
                    className="footer-left"
                    onClick={() => {
                        if (telemetry.jobName && telemetry.jobName !== "Route card not assigned") {
                            if (isGplastCondition) {
                                handleRejectParts();
                            } else {
                                handleRejectParts1(deviceNameIdJson[selectedMachine]);
                            }
                        }
                    }}
                    style={{ opacity: (telemetry.jobName && telemetry.jobName !== "Route card not assigned") ? 1 : 0.4, cursor: (telemetry.jobName && telemetry.jobName !== "Route card not assigned") ? "pointer" : "not-allowed" }}
                >
                    <FaPause />
                    Reject Parts
                </div>
                <div
                    className="footer-right"
                    onClick={() =>
                        openDownTime(selectedMachine, deviceNameIdJson[selectedMachine])
                    }                >
                    <RxCross2 />
                    Reason for Downtime
                </div>
            </div>
            <Dialog
                open={openDownTimeModal}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                        setopenDownTimeModal(false);
                    }
                }}
                sx={{
                    '& .MuiDialog-paper': {
                        width: '70%',
                        maxWidth: '70%'
                    }
                }}
            >
                <DialogTitle style={{ textAlign: "center" }}>
                    Assign Reason
                </DialogTitle>                <DialogContent>
                    <br></br>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '10px' }}>
                    </div>
                    {filteredResult.length > 0 ? (
                        <div style={{ marginTop: '20px', maxHeight: '300px', overflowY: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <colgroup>
                                    <col style={{ width: '20%' }} />
                                    <col style={{ width: '20%' }} />
                                    <col style={{ width: '12%' }} />
                                    <col style={{ width: '12%' }} />
                                    {(getCustomerId() === window._env_.GPLAST_CUSTOMER_ID) && (
                                        <col style={{ width: '12%' }} />
                                    )}
                                    <col style={{ width: '36%' }} />
                                </colgroup>
                                <thead>
                                    <tr style={{ backgroundColor: t.tableHeader }}>
                                        <th style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>Start Time (IST)</th>
                                        <th style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>End Time (IST)</th>
                                        <th style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>Duration</th>
                                        <th style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>Status</th>
                                        {(getCustomerId() === window._env_.GPLAST_CUSTOMER_ID) && (<th style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>Group</th>)}
                                        <th style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>Reason</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredResult.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>{formatEpochToIST(item.start)}</td>
                                            <td style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>{formatEpochToIST(item.end)}</td>
                                            <td style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>{formatDuration(item.duration)}</td>
                                            <td style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>{item.status}</td>
                                            {(getCustomerId() === window._env_.GPLAST_CUSTOMER_ID) && (
                                                <td>
                                                    <CustomDaySelect
                                                        name={`groupselected-${index}`}
                                                        value={item.groupselected || "all"}
                                                        onChange={(e) => handleGroupChange(index, e.target.value)}
                                                        label="Select Group"
                                                        options={reasonGroupOptions}
                                                    />
                                                </td>)}
                                            <td>
                                                <CustomDaySelect
                                                    name={`reasonselected-${index}`}
                                                    value={item.reasonselected || ""}
                                                    onChange={(e) => handleReasonChange(index, e.target.value)}
                                                    label="Select Reason"
                                                    required
                                                    options={
                                                        (() => {
                                                            const filtered = formattedReasons.filter(r =>
                                                                !item.groupselected || item.groupselected === "all" || r.group === item.groupselected
                                                            );
                                                            if (item.reasonselected === "UNKNOWN" && !filtered.some(r => r.value === "UNKNOWN")) {
                                                                return [{ value: "UNKNOWN", label: "UNKNOWN", group: item.groupselected }, ...filtered];
                                                            }
                                                            return filtered;
                                                        })()
                                                    }
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div style={{ marginTop: '20px', textAlign: 'center', color: '#888' }}>
                            <h3>No Data Found</h3>
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff4444' }} onClick={() => cancelreason()}>Cancel</Button>
                    <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff9800' }} onClick={handleSaveThreshold2}>Save</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openReject}
                onClose={() => setOpenReject(false)}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    sx: {
                        width: 800,
                        maxWidth: "95%",
                        borderRadius: "14px",
                        overflow: "hidden",
                    },
                }}
            >
                <div style={{
                    padding: "18px 24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: `1px solid ${t.headerBorder}`,
                    background: t.bg,
                }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <span style={{ fontSize: "22px" }}>🚫</span>
                        <span style={{ fontSize: "20px", fontWeight: "600", color: t.text, letterSpacing: "0.4px" }}>
                            Reject Parts Entry
                        </span>
                        {selectedRow?.machineName && (
                            <span style={{ fontSize: "20px", fontWeight: "600", color: t.text }}>
                                - {selectedRow.machineName}
                            </span>
                        )}
                        {selectedRow?.op?.operation_name && selectedRow.op.operation_name !== "No Operations" && (
                            <span style={{ fontSize: "15px", fontWeight: "500", color: t.textSub, marginLeft: "4px" }}>
                                ({selectedRow.op.operation_name})
                            </span>
                        )}
                    </div>
                </div>

                <DialogContent
                    sx={{
                        padding: "20px 24px",
                        background: t.dialogContent,
                        maxHeight: "70vh",
                        overflowY: "auto",
                        display: "flex",
                        flexDirection: "column",
                        gap: "18px"
                    }}
                >
                    {selectedRow && !isFetchingBluecard && (() => {
                        const actual = Number((selectedRow.op?.goodvsexp?.split("/") || [])[0] || 0);
                        const canReject = Math.max(0, actual - (existingCount || 0));
                        const rejectedAlready = existingCount || 0;
                        const stats = [
                            { label: "Actual", value: actual, color: "#fff", bg: "#1976d2", border: "#1565c0" },
                            { label: "Rejected", value: rejectedAlready, color: "#fff", bg: "#e53935", border: "#c62828" },
                            { label: "Remaining", value: canReject, color: "#fff", bg: "#2e7d32", border: "#1b5e20" },
                        ];
                        return (
                            <div style={{ display: "flex", gap: "10px", flexShrink: 0 }}>
                                {stats.map(s => (
                                    <div key={s.label} style={{ flex: 1, background: s.bg, border: `1px solid ${s.border}`, borderRadius: "8px", padding: "10px 8px", textAlign: "center" }}>
                                        <div style={{ fontSize: "14px", color: "rgba(255,255,255,0.85)", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "4px" }}>{s.label}</div>
                                        <div style={{ fontSize: "24px", fontWeight: "800", color: s.color, lineHeight: 1 }}>{s.value}</div>
                                    </div>
                                ))}
                            </div>
                        );
                    })()}

                    {prevOperatorData && prevOperatorData.count > 0 && (
                        <>
                            <div style={{ fontWeight: 600, fontSize: "16px", marginBottom: "8px" }}>
                                Previously Rejected
                            </div>

                            <div
                                style={{
                                    border: `1px solid ${t.borderLight}`,
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                    flexShrink: 0
                                }}
                            >
                                {/* Header */}
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: "100px 1fr 1fr",
                                        background: t.bgCard,
                                        borderBottom: `1px solid ${t.borderLight}`
                                    }}
                                >
                                    {["Count", "Reason", "Remark"].map((h, i) => (
                                        <div
                                            key={h}
                                            style={{
                                                padding: "14px",
                                                fontWeight: "600",
                                                fontSize: "15px",
                                                textAlign: "center",
                                                color: t.text,
                                                borderRight: i !== 2 ? `1px solid ${t.borderLight}` : "none"
                                            }}
                                        >
                                            {h}
                                        </div>
                                    ))}
                                </div>

                                {/* Rows container */}
                                <div
                                    style={{
                                        maxHeight: "260px", // ~4 rows
                                        overflowY: "auto"
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "100px 1fr 1fr",
                                            borderBottom: `1px solid ${t.borderLight}`,
                                            alignItems: "center",
                                            minHeight: "65px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                padding: "14px",
                                                textAlign: "center",
                                                fontSize: "15px",
                                                fontWeight: "500",
                                                color: t.text,
                                                borderRight: `1px solid ${t.borderLight}`,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}
                                        >
                                            {prevOperatorData.count}
                                        </div>

                                        <div
                                            style={{
                                                padding: "14px",
                                                fontSize: "15px",
                                                fontWeight: "500",
                                                color: t.text,
                                                borderRight: `1px solid ${t.borderLight}`,
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                                textAlign: "center"
                                            }}
                                        >
                                            {Array.isArray(prevOperatorData.reason)
                                                ? prevOperatorData.reason.join(", ")
                                                : prevOperatorData.reason || "-"}
                                        </div>

                                        <div
                                            style={{
                                                padding: "14px",
                                                fontSize: "15px",
                                                fontWeight: "500",
                                                color: t.text,
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                                textAlign: "center"
                                            }}
                                        >
                                            {prevOperatorData.remark || "-"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    <div style={{ fontWeight: 600, fontSize: "16px", color: t.text }}>Add New Reject Parts</div>

                    {rejectRows.map((row, idx) => {
                        if (row.isExisting) return null;
                        const actual = Number((selectedRow?.op?.goodvsexp?.split("/") || [])[0] || 0);
                        const allowed = Math.max(0, actual - (existingCount || 0));
                        const usedByOthers = rejectRows.reduce((sum, r, i) => i !== idx && !r.isExisting ? sum + Number(r.count || 0) : sum, 0);
                        const remaining = Math.max(0, allowed - usedByOthers);
                        return (
                            <div key={idx} style={{ display: "grid", gridTemplateColumns: "80px 260px 1fr 50px", borderBottom: `1px solid ${t.borderRow}`, alignItems: "center", gap: "8px", padding: "6px 8px" }}>
                                <div>
                                    <TextField
                                        type="number"
                                        value={row.count}
                                        size="small"
                                        label="Count"
                                        onFocus={() => { if (row.count === 0) setRejectRows(rejectRows.map((r, i) => i === idx ? { ...r, count: "" } : r)); }}
                                        onChange={(e) => {
                                            let val = e.target.value;
                                            if (val === "") val = "";
                                            else { val = Number(val); if (val > remaining) val = remaining; if (val < 0) val = 0; }
                                            setRejectRows(rejectRows.map((r, i) => i === idx ? { ...r, count: val } : r));
                                        }}
                                        inputProps={{ min: 0, max: remaining, style: { textAlign: "center", fontWeight: "600" } }}
                                        sx={{ width: "80px", "& .MuiInputBase-root": { height: "40px" } }}
                                    />
                                </div>
                                <div>
                                    <FormControl size="small" fullWidth>
                                        <InputLabel>Reason</InputLabel>
                                        <Select
                                            multiple
                                            label="Reason"
                                            value={row.reason || []}
                                            MenuProps={{ PaperProps: { style: { maxHeight: 220, overflowY: "auto" } } }}
                                            onChange={(e) => {
                                                const { value } = e.target;
                                                setRejectRows(rejectRows.map((r, i) => i === idx ? { ...r, reason: typeof value === "string" ? value.split(",") : value } : r));
                                            }}
                                            renderValue={(selected) => selected.length <= 2 ? selected.join(", ") : `${selected.slice(0, 2).join(", ")} ...`}
                                            sx={{ height: "40px" }}
                                        >
                                            {(qualityReasonList || []).map((item, i) => (
                                                <MenuItem key={i} value={item.reason}>
                                                    <Checkbox checked={(row.reason || []).includes(item.reason)} size="small" />
                                                    <ListItemText primary={item.reason} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div>
                                    <TextField
                                        value={row.remark}
                                        size="small"
                                        label="Remark"
                                        fullWidth
                                        onChange={(e) => setRejectRows(rejectRows.map((r, i) => i === idx ? { ...r, remark: e.target.value } : r))}
                                        sx={{ "& .MuiInputBase-root": { height: "40px" } }}
                                    />
                                </div>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <IconButton
                                        size="small"
                                        onClick={() => setRejectRows(rejectRows.filter((_, i) => i !== idx))}
                                        sx={{ background: "var(--y-bg-soft, #fafafa)", border: "1px solid #e0e0e0", "&:hover": { background: "#ffeaea", color: "#d32f2f" } }}
                                    >
                                        <DeleteOutlineIcon fontSize="small" />
                                    </IconButton>
                                </div>
                            </div>
                        );
                    })}

                    <div style={{ padding: "12px 0" }}>
                        <Button
                            variant="outlined"
                            size="small"
                            disabled={isMaxReached}
                            style={{
                                border: `1px solid ${isMaxReached ? "#bdbdbd" : "#EC6E17"}`,
                                color: isMaxReached ? "#9e9e9e" : "#EC6E17",
                                backgroundColor: "transparent",
                                cursor: isMaxReached ? "not-allowed" : "pointer"
                            }}
                            onClick={() => setRejectRows([...rejectRows, { count: 0, reason: [], remark: "", isExisting: false }])}
                        >
                            + Add Row
                        </Button>
                    </div>
                </DialogContent>

                <DialogActions sx={{ padding: "14px 24px", gap: 1.5, backgroundColor: "#f8f9fb", borderTop: "1px solid #e8eaf0" }}>
                    <Button
                        onClick={() => setOpenReject(false)}
                        variant="outlined"
                        sx={{ borderRadius: "4px", minWidth: "110px", borderColor: "#90a4ae", background: "#969392", color: "#ffffff", "&:hover": { borderColor: "#788388", background: "#a5a2a1" } }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSave}
                        disabled={(() => {
                            const newRows = rejectRows.filter(row => !row.isExisting);
                            if (newRows.length === 0) return true;
                            return newRows.some(row => (Number(row.count) || 0) <= 0 || (row.reason || []).length === 0 || !row.remark);
                        })()}
                        sx={{ borderRadius: "4px", minWidth: "110px", background: "#EC6E17", "&:hover": { background: "#e08529" } }}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            {confirmType && handleConfirmAlert()}

            <DynamicSlidingKeyboard touchEnabled={true} />

            {/* ===== "Who are you?" identify modal ===== */}
            {identifyModalOpen && (
                <div onClick={() => setIdentifyModalOpen(false)} style={{
                    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', zIndex: 9999,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
                }}>
                    <div onClick={(e) => e.stopPropagation()} style={{
                        background: 'var(--y-bg, #fff)', borderRadius: 16, padding: 28, width: 480, maxWidth: '95vw',
                        boxShadow: '0 12px 40px rgba(0,0,0,0.3)',
                    }}>
                        <div style={{ textAlign: 'center', marginBottom: 18 }}>
                            <div style={{ fontSize: 48, marginBottom: 8 }}>👤</div>
                            <div style={{ fontSize: 20, fontWeight: 800, color: '#111827' }}>Who are you?</div>
                            <div style={{ fontSize: 13, color: '#6b7280', marginTop: 4 }}>
                                Pick your name to see your shift assignment
                            </div>
                        </div>
                        <div style={{ maxHeight: 360, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 6 }}>
                            {operators.map((op, idx) => {
                                const opId = op.operatorid || op.id;
                                const hasAssignment = (assignmentPlan?.groups || []).some(g => String(g.operator_id) === String(opId));
                                return (
                                    <button
                                        key={opId || idx}
                                        onClick={() => {
                                            localStorage.setItem('identified_operator', JSON.stringify(op));
                                            setIdentifiedOperator(op);
                                            setIdentifyModalOpen(false);
                                        }}
                                        style={{
                                            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                            padding: '14px 16px', fontSize: 15, fontWeight: 700,
                                            background: 'var(--y-bg, #fff)', border: `2px solid ${hasAssignment ? '#16a34a' : '#e5e7eb'}`,
                                            borderRadius: 10, cursor: 'pointer', textAlign: 'left',
                                            transition: 'all 120ms ease',
                                        }}
                                        onMouseEnter={(e) => { e.currentTarget.style.background = '#f9fafb'; e.currentTarget.style.transform = 'translateX(2px)'; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.transform = 'none'; }}
                                    >
                                        <span>
                                            <div style={{ color: '#111827' }}>{op.operatorname || op.name}</div>
                                            {op.operatorid && <div style={{ fontSize: 11, color: '#6b7280', fontWeight: 500 }}>{op.operatorid}</div>}
                                        </span>
                                        {hasAssignment && <span style={{ fontSize: 11, color: '#16a34a', fontWeight: 800 }}>✓ Assigned</span>}
                                    </button>
                                );
                            })}
                            {(!operators || operators.length === 0) && (
                                <div style={{ textAlign: 'center', padding: 30, color: '#9ca3af' }}>
                                    No operators in the system yet
                                </div>
                            )}
                        </div>
                        <button onClick={() => setIdentifyModalOpen(false)} style={{
                            marginTop: 16, width: '100%', padding: 10,
                            background: 'var(--y-bg, #fff)', color: '#6b7280',
                            border: '1px solid var(--y-border, #e5e7eb)', borderRadius: 8, cursor: 'pointer',
                            fontSize: 13, fontWeight: 600,
                        }}>Cancel</button>
                    </div>
                </div>
            )}

            {/* ===== Visual shift briefing — color-coded, icon-driven, minimal text =====
                Design rules: NO paragraphs. Color carries state. Numbers prominent.
                Operator scans in 3 seconds: count, load, where to start. */}
            {checklistOpen && (
                <div style={{
                    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
                }}>
                    <div style={{
                        background: '#fff', borderRadius: 12, width: '90%', maxWidth: 540,
                        maxHeight: '85vh', overflow: 'auto', boxShadow: '0 20px 50px rgba(0,0,0,0.3)',
                    }}>
                        <div style={{
                            padding: '16px 20px', borderBottom: '1px solid #e5e7eb',
                            display: 'flex', alignItems: 'center', gap: 12,
                            background: 'linear-gradient(135deg, #f97316 0%, #fb923c 100%)',
                            color: '#fff', borderTopLeftRadius: 12, borderTopRightRadius: 12,
                        }}>
                            <div style={{ fontSize: 22 }}>✅</div>
                            <div style={{ flexGrow: 1 }}>
                                <div style={{ fontSize: 17, fontWeight: 800 }}>Pre-Shift Checklist</div>
                                <div style={{ fontSize: 11, opacity: 0.9 }}>
                                    {identifiedOperator?.operatorname || identifiedOperator?.name || ''} · {new Date().toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' })}
                                </div>
                            </div>
                            {checklistDoneToday && (
                                <button onClick={() => setChecklistOpen(false)} style={{
                                    padding: '4px 10px', fontSize: 11, fontWeight: 700,
                                    background: 'rgba(255,255,255,0.25)', color: '#fff',
                                    border: '1px solid rgba(255,255,255,0.4)', borderRadius: 4, cursor: 'pointer',
                                }}>close</button>
                            )}
                        </div>
                        <div style={{ padding: '20px 24px 24px' }}>
                            {(() => {
                                const cur = DEFAULT_CHECKLIST[checklistStep] || DEFAULT_CHECKLIST[0];
                                const done = !!checklistItems[cur.id];
                                const isLast = checklistStep === DEFAULT_CHECKLIST.length - 1;
                                const allRequiredDone = DEFAULT_CHECKLIST.every(it => !it.required || checklistItems[it.id]);
                                const doneCount = DEFAULT_CHECKLIST.filter(it => checklistItems[it.id]).length;
                                return (
                                    <>
                                        {/* Progress row */}
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
                                            <div style={{ fontSize: 13, fontWeight: 800, color: '#374151' }}>
                                                Step {checklistStep + 1} of {DEFAULT_CHECKLIST.length}
                                            </div>
                                            <div style={{ flexGrow: 1, height: 8, background: '#f3f4f6', borderRadius: 999, overflow: 'hidden' }}>
                                                <div style={{
                                                    width: ((doneCount) / DEFAULT_CHECKLIST.length) * 100 + '%',
                                                    height: '100%', background: 'linear-gradient(90deg, #f97316, #16a34a)',
                                                    transition: 'width 200ms ease',
                                                }} />
                                            </div>
                                            <div style={{ fontSize: 11, color: '#6b7280', fontWeight: 700 }}>
                                                {doneCount} / {DEFAULT_CHECKLIST.length}
                                            </div>
                                        </div>
                                        {/* Big icon card */}
                                        <div style={{
                                            display: 'flex', flexDirection: 'column', alignItems: 'center',
                                            padding: '32px 20px', borderRadius: 14,
                                            background: done ? '#f0fdf4' : '#fffbeb',
                                            border: '3px solid ' + (done ? '#16a34a' : '#fde68a'),
                                            transition: 'background 200ms ease, border-color 200ms ease',
                                        }}>
                                            <div style={{
                                                width: 120, height: 120, borderRadius: '50%',
                                                background: done ? '#dcfce7' : '#fef3c7',
                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                fontSize: 72, marginBottom: 16,
                                                boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                                                transition: 'background 200ms ease',
                                            }}>{cur.icon}</div>
                                            <div style={{ fontSize: 22, fontWeight: 900, color: '#111827', textAlign: 'center' }}>
                                                {cur.label}
                                                {cur.required && <span style={{ color: '#dc2626', marginLeft: 6 }}>*</span>}
                                            </div>
                                            <div style={{ fontSize: 14, color: '#6b7280', marginTop: 4, textAlign: 'center', fontWeight: 600 }}>
                                                {cur.sub}
                                            </div>
                                            {done && (
                                                <div style={{
                                                    marginTop: 18, padding: '6px 16px',
                                                    background: '#16a34a', color: '#fff', borderRadius: 999,
                                                    fontSize: 12, fontWeight: 800,
                                                }}>✓ CONFIRMED</div>
                                            )}
                                        </div>
                                        {/* Big buttons */}
                                        <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
                                            {!done ? (
                                                <>
                                                    {!cur.required && (
                                                        <button
                                                            onClick={() => {
                                                                if (!isLast) setChecklistStep(checklistStep + 1);
                                                            }}
                                                            style={{
                                                                flex: '1', padding: '18px 16px', fontSize: 16, fontWeight: 800,
                                                                background: '#f3f4f6', color: '#6b7280',
                                                                border: '2px solid #d1d5db', borderRadius: 10, cursor: 'pointer',
                                                            }}
                                                        >Skip</button>
                                                    )}
                                                    <button
                                                        onClick={() => {
                                                            setChecklistItems({ ...checklistItems, [cur.id]: true });
                                                            setTimeout(() => {
                                                                if (!isLast) setChecklistStep(checklistStep + 1);
                                                            }, 350);
                                                        }}
                                                        style={{
                                                            flex: '2', padding: '18px 16px', fontSize: 17, fontWeight: 900,
                                                            background: '#16a34a', color: '#fff',
                                                            border: 'none', borderRadius: 10, cursor: 'pointer',
                                                            boxShadow: '0 4px 12px rgba(22,163,74,0.3)',
                                                        }}
                                                    >✓ Yes, done</button>
                                                </>
                                            ) : (
                                                <>
                                                    <button
                                                        onClick={() => setChecklistItems({ ...checklistItems, [cur.id]: false })}
                                                        style={{
                                                            flex: '1', padding: '14px 16px', fontSize: 13, fontWeight: 700,
                                                            background: '#fff', color: '#dc2626',
                                                            border: '2px solid #fca5a5', borderRadius: 10, cursor: 'pointer',
                                                        }}
                                                    >Undo</button>
                                                    {isLast ? (
                                                        <button
                                                            onClick={submitChecklist}
                                                            disabled={!allRequiredDone}
                                                            style={{
                                                                flex: '3', padding: '18px 16px', fontSize: 17, fontWeight: 900,
                                                                background: allRequiredDone ? '#16a34a' : '#d1d5db',
                                                                color: '#fff', border: 'none', borderRadius: 10,
                                                                cursor: allRequiredDone ? 'pointer' : 'not-allowed',
                                                                boxShadow: allRequiredDone ? '0 4px 12px rgba(22,163,74,0.3)' : 'none',
                                                            }}
                                                        >{allRequiredDone ? '✓ Mark complete + start work' : 'Complete required items first'}</button>
                                                    ) : (
                                                        <button
                                                            onClick={() => setChecklistStep(checklistStep + 1)}
                                                            style={{
                                                                flex: '3', padding: '18px 16px', fontSize: 17, fontWeight: 900,
                                                                background: '#3b82f6', color: '#fff',
                                                                border: 'none', borderRadius: 10, cursor: 'pointer',
                                                                boxShadow: '0 4px 12px rgba(59,130,246,0.3)',
                                                            }}
                                                        >Next →</button>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                        {/* Back + dot indicators */}
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 14 }}>
                                            <button
                                                onClick={() => setChecklistStep(Math.max(0, checklistStep - 1))}
                                                disabled={checklistStep === 0}
                                                style={{
                                                    padding: '6px 14px', fontSize: 12, fontWeight: 700,
                                                    background: 'transparent', color: checklistStep === 0 ? '#d1d5db' : '#6b7280',
                                                    border: 'none', cursor: checklistStep === 0 ? 'not-allowed' : 'pointer',
                                                }}
                                            >← Back</button>
                                            <div style={{ display: 'flex', gap: 6, flexGrow: 1, justifyContent: 'center' }}>
                                                {DEFAULT_CHECKLIST.map((it, idx) => {
                                                    const itemDone = !!checklistItems[it.id];
                                                    const isCurrent = idx === checklistStep;
                                                    return (
                                                        <button
                                                            key={it.id}
                                                            onClick={() => setChecklistStep(idx)}
                                                            title={it.label}
                                                            style={{
                                                                width: isCurrent ? 22 : 10, height: 10, borderRadius: 999,
                                                                background: itemDone ? '#16a34a' : (isCurrent ? '#f97316' : '#e5e7eb'),
                                                                border: 'none', cursor: 'pointer', padding: 0,
                                                                transition: 'width 150ms ease, background 150ms ease',
                                                            }}
                                                        />
                                                    );
                                                })}
                                            </div>
                                            <div style={{ width: 50 }} />
                                        </div>
                                    </>
                                );
                            })()}
                        </div>
                    </div>
                </div>
            )}
            {briefingOpen && myAssignedGroup && (() => {
                const SERVER_URL = (window._env_?.SERVER_URL2 || '').replace(/\/$/, '');
                const busyPct = myAssignedGroup.busy_pct;
                const roundMin = myAssignedGroup.round_time_min;
                // Color codes by load level
                const loadColor = busyPct == null ? { bg: '#f3f4f6', border: '#9ca3af', text: '#374151', label: 'OK' }
                    : busyPct >= 85 ? { bg: '#fee2e2', border: '#dc2626', text: '#7a0000', label: 'HEAVY' }
                    : busyPct >= 70 ? { bg: '#fef3c7', border: '#d97706', text: '#7a4a00', label: 'BUSY' }
                    : { bg: '#dcfce7', border: '#16a34a', text: '#14532d', label: 'EASY' };
                return (
                <div style={{
                    position: 'fixed', inset: 0,
                    background: 'rgba(15, 23, 42, 0.75)',
                    backdropFilter: 'blur(4px)',
                    zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
                }}>
                    <div style={{
                        background: 'var(--y-bg, #fff)', borderRadius: 16, padding: 22, width: 760, maxWidth: '96vw',
                        maxHeight: '94vh', overflowY: 'auto',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
                    }}>
                        {/* Tight welcome — one line */}
                        <div style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            paddingBottom: 12, borderBottom: '1px solid var(--y-border, #e5e7eb)', marginBottom: 16,
                        }}>
                            <div style={{ fontSize: 22, fontWeight: 900, color: '#111827' }}>
                                👋 {identifiedOperator?.operatorname || 'Operator'}
                            </div>
                            <div style={{ fontSize: 11, color: '#9ca3af', fontWeight: 600 }}>
                                {new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'short', weekday: 'short' })}
                            </div>
                        </div>

                        {/* 3 color-coded number tiles — no labels needed for icon ones */}
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, marginBottom: 16 }}>
                            <div style={{
                                padding: 12, background: '#eff6ff', borderRadius: 10, textAlign: 'center',
                                border: '1px solid #bfdbfe',
                            }}>
                                <div style={{ fontSize: 28, fontWeight: 900, color: '#1e40af', lineHeight: 1 }}>
                                    {myAssignedGroup.machines.length}
                                </div>
                                <div style={{ fontSize: 18, marginTop: 2 }}>🏭</div>
                            </div>
                            <div style={{
                                padding: 12, background: loadColor.bg, borderRadius: 10, textAlign: 'center',
                                border: `1px solid ${loadColor.border}`,
                            }}>
                                <div style={{ fontSize: 28, fontWeight: 900, color: loadColor.text, lineHeight: 1 }}>
                                    {busyPct != null ? `${busyPct}%` : '—'}
                                </div>
                                <div style={{
                                    fontSize: 10, fontWeight: 800, letterSpacing: 0.6,
                                    color: loadColor.text, marginTop: 4,
                                }}>{loadColor.label}</div>
                            </div>
                            <div style={{
                                padding: 12, background: '#f3e8ff', borderRadius: 10, textAlign: 'center',
                                border: '1px solid #d8b4fe',
                            }}>
                                <div style={{ fontSize: 28, fontWeight: 900, color: '#6b21a8', lineHeight: 1 }}>
                                    {roundMin != null ? roundMin : '—'}
                                    <span style={{ fontSize: 14, marginLeft: 3, fontWeight: 700 }}>min</span>
                                </div>
                                <div style={{ fontSize: 18, marginTop: 2 }}>🔁</div>
                            </div>
                        </div>

                        {/* Machine cards — first card has START HERE callout */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: `repeat(${Math.min(myAssignedGroup.machines.length, 4)}, 1fr)`,
                            gap: 10, marginBottom: 18, alignItems: 'stretch',
                        }}>
                            {myAssignedGroup.machines.map((m, i) => {
                                const isStart = i === 0;
                                return (
                                    <div key={m.device_id} style={{
                                        position: 'relative',
                                        background: isStart
                                            ? 'linear-gradient(180deg, #fff7ed 0%, #ffedd5 100%)'
                                            : '#fff',
                                        border: `2px solid ${isStart ? '#F99022' : '#e5e7eb'}`,
                                        borderRadius: 10, padding: 10, textAlign: 'center',
                                        boxShadow: isStart ? '0 4px 14px rgba(249,144,34,0.35)' : 'none',
                                        transform: isStart ? 'scale(1.04)' : 'scale(1)',
                                        transition: 'all 200ms ease',
                                    }}>
                                        {isStart && (
                                            <div style={{
                                                position: 'absolute', top: -10, left: '50%', transform: 'translateX(-50%)',
                                                background: '#F99022', color: '#fff',
                                                padding: '3px 10px', borderRadius: 999,
                                                fontSize: 10, fontWeight: 900, letterSpacing: 0.7, whiteSpace: 'nowrap',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
                                            }}>▶ START HERE</div>
                                        )}
                                        {/* Number badge */}
                                        <div style={{
                                            position: 'absolute', top: 6, left: 6,
                                            width: 22, height: 22, borderRadius: '50%',
                                            background: isStart ? '#F99022' : '#9ca3af',
                                            color: '#fff', fontSize: 11, fontWeight: 900,
                                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        }}>{i + 1}</div>
                                        {/* Image OR factory emoji */}
                                        {m.image_url ? (
                                            <img
                                                src={`${SERVER_URL}${m.image_url}`}
                                                alt={m.name}
                                                style={{
                                                    width: '100%', height: 80, objectFit: 'contain',
                                                    marginTop: 4, marginBottom: 4,
                                                }}
                                            />
                                        ) : (
                                            <div style={{ fontSize: 40, lineHeight: 1, margin: '12px 0 4px' }}>🏭</div>
                                        )}
                                        <div style={{ fontSize: 14, fontWeight: 800, color: '#111827', marginTop: 4 }}>
                                            {m.name}
                                        </div>
                                        {m.component_code && (
                                            <div style={{
                                                marginTop: 4, display: 'inline-block',
                                                padding: '2px 8px', background: 'var(--y-bg, #f3f4f6)', color: '#374151',
                                                borderRadius: 3, fontSize: 10, fontWeight: 700, fontFamily: 'monospace',
                                            }}>{m.component_code}</div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>

                        {/* Single CTA — big, green = go */}
                        <button onClick={acknowledgeBrief} style={{
                            width: '100%', padding: '18px 24px',
                            background: 'linear-gradient(180deg, #22c55e 0%, #16a34a 100%)',
                            color: '#fff', border: 'none', borderRadius: 12,
                            fontSize: 20, fontWeight: 900, cursor: 'pointer',
                            boxShadow: '0 4px 14px rgba(34,197,94,0.4)',
                            letterSpacing: 0.5, minHeight: 56,
                        }}>
                            ▶ START
                        </button>
                    </div>
                </div>
                );
            })()}

            {activeView !== 'efficiency' && (
              <div style={{ position:'fixed', inset:0, background:'#f4f6f9', zIndex:1000, overflow:'auto' }}>
                <div style={{ display:'flex', alignItems:'center', gap:16, padding:'14px 24px', background:'#fff', borderBottom:'1px solid #e5e7eb' }}>
                  <button type="button" onClick={()=>setActiveView('efficiency')} style={{ border:'1px solid #e5e7eb', background:'#fff', borderRadius:8, padding:'6px 12px', cursor:'pointer', fontWeight:700, color:'#374151' }}>&larr; Efficiency</button>
                  <div style={{ display:'inline-flex', background:'#f3f4f6', borderRadius:10, padding:3 }}>
                    {[['mes','MES Dashboard'],['report','Production Report']].map(([v,label])=>(
                      <button key={v} type="button" onClick={()=>setActiveView(v)} style={{ border:'none', cursor:'pointer', padding:'7px 14px', borderRadius:8, fontSize:12, fontWeight:700, background: activeView===v?'#f97316':'transparent', color: activeView===v?'#fff':'#6b7280' }}>{label}</button>
                    ))}
                  </div>
                  <strong style={{ marginLeft:'auto', color:'#111827', fontSize:15 }}>{activeView==='mes'?'MES Dashboard':'Production Report'}</strong>
                </div>
                <div style={{ padding:24, color:'#6b7280' }}>Live WO operation table wiring in progress &mdash; next increment.</div>
              </div>
            )}
        </div>
    );
}

export default Operator;